// Global Variable
var intlTelInstance = {};

$(function() {
    onloadTm4u();
    tablePaginate();
    toggleBodyScroll();
    if (!document.referrer.includes('choose-from-your-nearest-advisors')) {
        checkReferral();
    }
    if (window.location.pathname.includes('/choose-from-your-nearest-advisors')) {
        showMapLoading();
    }
    initMySwiper();
    initTextColumnsFlickity();
    updateCountryState();
    enableAccountUpdateWhenFoundChanges();
    if (window.location.pathname.includes('/account') || window.location.pathname.includes('/pages/newcomer-step-2') || window.location.pathname.includes('/pages/newcomer-owned')) {
      initIntlTelInput();
    }
    onloadInitFunctions();
    onloadGetAnchorLink();
    setTimeout(() => {
        triggerMapPopup();
        bindFunction();
    }, 4500);
    setTimeout(() => {
        eventListnerTriggerPopup();
    }, 4500);
    if (document.referrer.includes('register')) {
        onLoadLoader();
    }
    removeProfileUpdateError();
    // initIntlTelInput();
    //advisorreportload();
    initInlineDatePicker();
    toggleMegaMenuOverlay();
    // hoverATCbutton();

    if (window.theme.taxInvoice.is_tax_invoice_enabled && window.location.pathname.includes('/cart')) {
        getTaxAttr();
    }
})

const getGenericAlertElements = () => {
    const popup = $('#jsc-generic-alert');
    if (!popup.length) {
        return null;
    }

    return {
        popup,
        overlay: popup.find('.jsc-mixing-popup-overlay'),
        closeButton: popup.find('.jsc-mixing-popup-close'),
        confirmButton: popup.find('#jsc-generic-alert-confirm'),
        messageContainer: popup.find('#jsc-generic-alert-message')
    };
};

const showGenericAlert = (message, options = {}) => {
    const elements = getGenericAlertElements();
    const fallbackMessage = message == null ? '' : message;
    if (!elements) {
        window.alert(String(fallbackMessage));
        return;
    }

    const { confirmLabel = 'OK', onConfirm } = options;
    const normalizedMessage = Array.isArray(fallbackMessage)
        ? fallbackMessage.join('<br>')
        : String(fallbackMessage).replace(/\n/g, '<br>');

    elements.messageContainer.html(normalizedMessage);
    elements.confirmButton.text(confirmLabel);

    const closePopup = () => {
        elements.popup.css('display', 'none');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
        elements.confirmButton.off('click', handleConfirm);
        elements.closeButton.off('click', handleClose);
        elements.overlay.off('click', handleClose);
    };

    const handleClose = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        closePopup();
    };

    const handleConfirm = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (typeof onConfirm === 'function') {
            onConfirm();
        }
        closePopup();
    };

    elements.closeButton.off('click').on('click', handleClose);
    elements.overlay.off('click').on('click', handleClose);
    elements.confirmButton.off('click').on('click', handleConfirm);

    elements.popup.css('display', 'block');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    requestAnimationFrame(() => {
        elements.confirmButton.trigger('focus');
    });
};

window.showGenericAlert = showGenericAlert;

const isCustomerLoggedIn = () => {
    const customerInfo = window.theme && window.theme.customerInfo;
    if (!customerInfo) {
        return false;
    }
    const name = (customerInfo.name || '').trim();
    return name !== '' && name.toLowerCase() !== 'guest';
};

const showLoginRequiredPrompt = () => {
    const message = 'To complete your purchase, please log in or set up an account first.';
    const baseLoginUrl = (window.theme && window.theme.routes && window.theme.routes.accountLogin) || '/account/login';
    const connector = baseLoginUrl.includes('?') ? '&' : '?';
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
    const loginUrl = `${baseLoginUrl}${connector}return_url=${returnUrl}`;

    showGenericAlert(message, {
        confirmLabel: 'OK',
        onConfirm: () => {
            window.location.href = loginUrl;
        }
    });
};

initMySwiper = () => {
    console.log('init mySwiper');
    $('.swiper.mySwiper').each(function(index, element) {
        var _this = $(element);
        var autoplay = _this.data('autoplay');
        var autoplaySpeed = _this.data('autoplay-speed');

        var swiper_option = {
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
            loop: true,
            initialSlide : 0
        }

        if (autoplay && autoplaySpeed != '') {
            swiper_option['autoplay'] = {
                delay: autoplaySpeed,
                disableOnInteraction: false
            }
        }
        var swiper = new Swiper(this, swiper_option);
    });
}

updateSwatchFilter = (e) => {
    const _this = $(e);
    var checkbox = _this.find('input[type="checkbox"]');
    var tag = _this.parent('.tag');

    if(checkbox && tag) {
        if(checkbox.is(':checked')) {
            // checkbox.val(0);
            checkbox.removeAttr('checked');
            tag.removeClass('tag--active');
        } else {
            // checkbox.val(1);
            checkbox.prop('checked', true);
            tag.addClass('tag--active');
        }
    }
}



const onloadInitFunctions = () => {
    // When returning from advisor page via Back button: clear demo selection and leave radios unselected
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('from_advisor_back') === '1') {
        localStorage.setItem('Previous Demo Experience?', '-');
        localStorage.setItem('Would you like to select a preferred advisor?', '-');
        localStorage.setItem('Advisor ID', '-');
        localStorage.setItem('Advisor Name', '-');
        if (typeof CartJS !== 'undefined' && CartJS.setAttributes) {
            CartJS.setAttributes({
                "Previous Demo Experience?": "-",
                "Advisor ID": "-",
                "Advisor Name": "-",
                "Would you like to select a preferred advisor?": "-"
            });
        }
        if (window.history && window.history.replaceState) {
            urlParams.delete('from_advisor_back');
            const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
            window.history.replaceState({}, '', newUrl);
        }
    }
    advisorRadioButtonHandling();
    // fetchAdvisorJson();
    getAdvisorLocalStorage();
    loadAdvisorName();
    // initAdvisorSelector();
};

loadAdvisorName = async () =>{
    if ($('#jsc-cart-advisor-name').length) {
        const advisor_id = localStorage.getItem('Advisor ID');
        const advisor_name = localStorage.getItem('Advisor Name');
        if (advisor_id && advisor_id != '-' && advisor_id != '') {
            const advisorValidation = await validateAdvisor(advisor_id);
            console.log('loadAdvisorName - advisorValidation: ', advisorValidation);
            if (advisorValidation) {
                $('#jsc-cart-advisor-name').text(advisor_name);
                $('#jsc-cart-advisor-name-input').val(advisor_name);
            } else {
                clearAdvisorData();
            }
        } else {
            clearAdvisorData();
        }
    }
}

// Scripts for Advisor feature starts here
/**
 * HTML template for the advisor selection input field.
 * @type {string}
 */
const search_advisor_field = `
    <div class="jsc-advisor m-t-15 relative">
        <p class="m-b-5">Yes, I've had a demo before. Advisor ID/Name:</p>
        <input id="search-advisor" type="text" value="" aria-label="Yes, I've had a demo before. Advisor ID/Name" name="attributes[Advisor ID]" class="advisor-text full-width full-max-width">
        <div id="advisor-search-results" class="advisor-search-results"></div>
    </div>
`;

/**
 * Handles the changes to the demo radio buttons and updates local storage.
 */
const advisorRadioButtonHandling = () => {
    $('.demo-radio').change(function(event, data) {
        const selectedValue = $(this).val();
        localStorage.setItem('Previous Demo Experience?', selectedValue);
        if (!data || data.resetInterestedAdvisorValue === true) {
            localStorage.setItem('Would you like to select a preferred advisor?', '-');
        }
        // localStorage.setItem('Advisor ID', '');
        
        $('#jsc-advisor-error-msg').hide();
        handleAdvisorDisplay(selectedValue);
    });

    $(document).on('change', '.interested-advisor-radio', function() {
        const selectedValue = $(this).val();
        localStorage.setItem('Would you like to select a preferred advisor?', selectedValue);
        // localStorage.setItem('Advisor ID', '');
        
        $('#jsc-advisor-error-msg').hide();
        if (selectedValue === 'Yes') {
            $('.jsc-customer-input').append(search_advisor_field);
            if (localStorage.getItem('Advisor ID') && localStorage.getItem('Advisor ID') != '-') {
                $('#search-advisor').val(localStorage.getItem('Advisor ID'));
            } else {
                location.href = `/pages/${$('#advisor_page').val()}?advisor=cart`;
            }
            handleAdvisorSelector(selectedValue, 'interested-advisor-radio');
        } else if (selectedValue === 'No'){
            if (!confirm('Please confirm that you would like to proceed to checkout without selecting a preferred advisor.')) {
                // If not confirmed, revert selection
                // Find the Yes radio and check it back if it exists
                $(this).prop('checked', false);
                $("#interested-advisor-yes").prop('checked', true).trigger('change');
                localStorage.setItem('Would you like to select a preferred advisor?', 'Yes');
            } else {
                $('.jsc-advisor').remove();
                Promise.resolve(handleAdvisorSelector(selectedValue, 'interested-advisor-radio'))
                .then(() => clearAdvisorData())
                .then(() => location.reload());
            }
        }
    });
};

/**
 * Displays the advisor selection or interested advisor options based on the selected value.
 * @param {string} selectedValue - The value selected from the demo radio buttons.
 */
const handleAdvisorDisplay = (selectedValue) => {
    if (selectedValue === 'Yes') {
        $('.jsc-interested-advisor').remove();
        $('.jsc-advisor').remove();
        $('.jsc-customer-input').append(search_advisor_field);
        $('#search-advisor').val(localStorage.getItem('Advisor ID'));
        
        setTimeout(() => {
            if (localStorage.getItem('Advisor ID') == undefined || localStorage.getItem('Advisor ID') == null || localStorage.getItem('Advisor ID') == '-') {
                location.href = `/pages/${$('#advisor_page').val()}?advisor=cart`;
            }
        }, 3);

        handleAdvisorSelector(selectedValue, 'demo-radio');
    } else {
        // const refId = localStorage.getItem('Referral ID');
        // if (refId == null || refId == undefined || refId == '') {
        $('.jsc-advisor').remove();
        const noResponseHtml = `
            <div class="jsc-interested-advisor m-t-15">
                <p class="m-b-5">Would you like to select a preferred advisor? <span style="color: red;">*</span></p>
                <span>
                    <input id="interested-advisor-yes" type="radio" value="Yes" aria-label="Yes" name="attributes[Would you like to select a preferred advisor?]" class="m-r-5 interested-advisor-radio">
                    <label class="d-inline m-r-15" for="interested-advisor-yes">Yes</label>
                </span>
                <span>
                    <input id="interested-advisor-no" type="radio" value="No" aria-label="No" name="attributes[Would you like to select a preferred advisor?]" class="m-r-5 interested-advisor-radio">
                    <label class="d-inline m-r-15" for="interested-advisor-no">No</label>
                </span>
            </div>`;
        $('.jsc-customer-input').append(noResponseHtml);
        // }
    }
};

const handleAdvisorSelector = (selectedValue, radioClass) => {
    var removeAdvisor = false;
    var demoRadio = false;
    const advisorID = localStorage.getItem('Advisor ID');
    const advisorName = localStorage.getItem('Advisor Name');

    if (radioClass == 'demo-radio' && selectedValue == "Yes") {
        demoRadio = true;
        removeAdvisor = false;
        if ($('.jsc-advisor-select').hasClass('d-none')) {
            $('.jsc-advisor-select').removeClass('d-none');
        }
    }

    if (radioClass == 'interested-advisor-radio') {
        if (selectedValue === 'No') {
            if (!$('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').addClass('d-none');
                $('#jsc-cart-advisor-name-input').val('-');
            }
            removeAdvisor = true;
        } else {
            if ($('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').removeClass('d-none');
            }
            removeAdvisor = false;
        }
    }

    if (demoRadio && selectedValue == "Yes" && !removeAdvisor) {
        return CartJS.setAttributes({
            "Previous Demo Experience?": "Yes",
            "Advisor ID": `${advisorID ? advisorID : '-'}`,
            "Advisor Name": `${advisorName ? advisorName : '-'}`,
            "Would you like to select a preferred advisor?": "-"
        });
    } else {
        if (removeAdvisor) {
            return CartJS.setAttributes({
                "Advisor ID": "-",
                "Advisor Name": "-",
                "Would you like to select a preferred advisor?": "No"
            });
        } else {
            return CartJS.setAttributes({
                "Advisor ID": `${advisorID ? advisorID : '-'}`,
                "Advisor Name": `${advisorName ? advisorName : '-'}`,
                "Would you like to select a preferred advisor?": "Yes"
            });
        }
    }

    // $(document).on('cart.requestComplete', function(event, cart) {
    //     console.log('cart request complete');
    // })
}

// start: add advisor info at line item properties
addAdvisorInfoAtLineItemProperties = async () => {
    try {
        // fetch cart items
        const cart = await fetch('/cart.js').then(res => res.json());

        // Filter items that are advisor products
        const advisorItems = cart.items.filter(item => item.properties && item.properties._is_advisor_product === "true");
        console.log('advisorItems: ', advisorItems);
        const updatePromises = advisorItems.map(item => {
            const updatedProps = {
                ...item.properties,
                "_Previous Demo Experience?": $('.demo-radio:checked').val() || '-',
                "Advisor ID": localStorage.getItem('Advisor ID') || '-',
                "_Advisor Name": localStorage.getItem('Advisor Name') || '-',
                "_Would you like to select a preferred advisor?": $('.interested-advisor-radio:checked').val() || '-'
            };
            delete updatedProps["Previous Demo Experience?"];
            delete updatedProps["Advisor Name"];
            delete updatedProps["Would you like to select a preferred advisor?"];

            return CartJS.updateItemById(item.key, item.quantity, updatedProps);
        });
        console.log('updatePromises: ', updatePromises);

        // Wait for all updates to complete
        await Promise.all(updatePromises);
        return true;
    } catch (error) {
        console.error("Error updating line item properties:", error);
        return false;
    }
}
// end: add advisor info at line item properties
// start: add tax invoice info at line item properties
addTaxInvoiceInfoAtLineItemProperties = async () => {
    console.log('adding tax invoice info line item properties...');
    try {
        // fetch cart items
        const cart = await fetch('/cart.js').then(res => res.json());
        const cart_attr_obj = cart.attributes;
        const cart_items = cart.items;

        console.log('cart_attr_obj: ', cart_attr_obj, 'cart_items: ', cart_items);
        const tax_invoice_obj = {};
        if (cart_attr_obj['Tax Invoice for Legal Compliance']) {
            tax_invoice_obj['_Tax Invoice for Legal Compliance'] = cart_attr_obj['Tax Invoice for Legal Compliance'];
            if (cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Company') {
                // tax_invoice_obj['Company Type'] = cart_attr_obj['Company Type'];
                tax_invoice_obj['_Company Name'] = cart_attr_obj['Company Name'];
                tax_invoice_obj['_Company Registration No'] = cart_attr_obj['Company Registration No'];
            } else if (cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Mobile Carrier No') {
                tax_invoice_obj['_Mobile Carrier No'] = cart_attr_obj['Mobile Carrier No'];
            }
            tax_invoice_obj['_Tax Policy'] = cart_attr_obj['Tax Policy'];
        }
        console.log('tax_invoice_obj: ', tax_invoice_obj);
        if (Object.keys(tax_invoice_obj).length > 0) {
            const updatePromises = cart_items.map(item => {
                const updatedProps = {
                    ...item.properties,
                    ...tax_invoice_obj
                };
                if (cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Company') {
                    delete updatedProps["_Mobile Carrier No"];
                } else if(cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Mobile Carrier No') {
                    // delete updatedProps["Company Type"];
                    delete updatedProps["_Company Name"];
                    delete updatedProps["_Company Registration No"];
                } else if (cart_attr_obj['Tax Invoice for Legal Compliance'] == 'Personal') {
                    delete updatedProps["_Company Name"];
                    delete updatedProps["_Company Registration No"];
                    delete updatedProps["_Mobile Carrier No"];
                }
                return CartJS.updateItemById(item.key, item.quantity, updatedProps);
            });
            await Promise.all(updatePromises);
        }
        return true;
    } catch (error) {
        console.error("Error updating line item properties:", error);
        return false;
    }
}
// end: add tax invoice info at line item properties

// Milliseconds to wait for the cart attribute update before sending the
// shopper to checkout anyway, so a request that never completes cannot leave
// the loading overlay covering the page.
const CHECKOUT_REQUEST_TIMEOUT = 8000;
let checkoutRequestTimer = null;
let checkoutRequestCompleteHandler = null;

const clearCheckoutRequest = () => {
    clearTimeout(checkoutRequestTimer);
    checkoutRequestTimer = null;

    if (checkoutRequestCompleteHandler) {
        $(document).off('cart.requestComplete', checkoutRequestCompleteHandler);
        checkoutRequestCompleteHandler = null;
    }
};

/**
 * Binds a one-shot cart.requestComplete handler and a timeout fallback so a
 * request that never completes cannot leave the loading overlay covering the page.
 */
const bindCheckoutRequestComplete = (handler) => {
    clearCheckoutRequest();
    checkoutRequestCompleteHandler = handler;
    $(document).one('cart.requestComplete', handler);
    checkoutRequestTimer = setTimeout(handler, CHECKOUT_REQUEST_TIMEOUT);
};

/**
 * Sends the shopper to Shopify checkout once the cart attributes are saved.
 */
const submitShopifyCheckout = () => {
    clearCheckoutRequest();
    $('.jsc-loader-overlay').hide();
    // $('.shopify-checkout-btn').click();
    location.href = '/checkout';
};

/**
 * Clears the loading state left behind on the cart when the shopper leaves for
 * checkout. Browsers keep the page in their back-forward cache, so on a back
 * navigation the overlay and button spinner are restored as they were and
 * swallow every click until the shopper reloads.
 */
const resetCartLoadingState = () => {
    clearCheckoutRequest();
    $('.jsc-loader-overlay').hide();
    $('.cart__checkout, .btn-split-payment').removeClass('btn--loading');
    $('body').removeClass('disabled-event');

    // The cart may have changed while the shopper was in checkout.
    document.dispatchEvent(new CustomEvent('cart:build'));
};

window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
        resetCartLoadingState();
    }
});

/**
 * Handles the checkout process, setting attributes and verifying advisor selections.
 * @param {Event} e - The event object from the checkout action.
 */
const checkout = async (e,is_advisor_product, is_advisor) => {
    const _this = $(e);
    var $loader = $('.jsc-loader-overlay');
    const refId = localStorage.getItem('Referral ID');
    let isValid = true;
    let addAdvisorProperties = false;
    const demoVal = $('.demo-radio:checked').val();
    const isTaxInvoiceEnabled = $('#CartPageForm').data('tax-invoice-enabled');
    const containsMainProduct = $('#CartPageForm').data('contains-main-product') || "";
    let cartAttributes = {};
    console.log('refId: ', refId);

    // if (!isCustomerLoggedIn()) {
    //     showLoginRequiredPrompt();
    //     return false;
    // }

    $loader.show();

    // if (is_advisor_product && is_advisor && refId) {
    //     if (demoVal === undefined) {
    //         isValid = false;
    //         $('#jsc-advisor-error-msg').show();
    //     } else {
    //         addAdvisorProperties = true;
    //         $('#jsc-advisor-error-msg').hide();
    //     }
    // } else 
    if (is_advisor_product && is_advisor) {
        if (demoVal === undefined) {
            isValid = false;
            $('#jsc-advisor-error-msg').show();
        } else {
            addAdvisorProperties = true;
            if (demoVal === 'Yes') {
                const advisorIdValue = $('#search-advisor').val();
                localStorage.setItem('Advisor ID', advisorIdValue);
                $('#jsc-advisor-error-msg').hide();
            } else {
                const interestedAdvisor = $('.interested-advisor-radio:checked').val();
                if (interestedAdvisor === undefined) {
                    isValid = false;
                    $('#jsc-advisor-error-msg').show();
                } else {
                    if (interestedAdvisor === 'Yes') {
                        const advisorIdValue = $('#search-advisor').val();
                        localStorage.setItem('Advisor ID', advisorIdValue);
                        $('#jsc-advisor-error-msg').hide();
                    }
                }
            }
        }
    }

    if (!$('#CartTerms').is(':checked')) {
        isValid = false;
        showGenericAlert("You must agree with the terms and conditions of sales.")
    }

    if (isTaxInvoiceEnabled) {
        const saveResult = await saveCartAttr();
        $loader.show();
        if (saveResult === false) {
            isValid = false;
        }
    }

    if (isValid && is_advisor_product && is_advisor && addAdvisorProperties) {
      const addedAdvisorInfo = await addAdvisorInfoAtLineItemProperties();
      if (!addedAdvisorInfo) isValid = false;
    }

    if (isValid && isTaxInvoiceEnabled) {
      const addedTaxInvoiceInfo = await addTaxInvoiceInfoAtLineItemProperties();
      if (!addedTaxInvoiceInfo) {
        isValid = false;
      }
    }

    if (isValid) {
        // cart.requestComplete also fires for cart requests made elsewhere, so
        // bind one-shot and drop any handler left behind by an earlier click.
        bindCheckoutRequestComplete(submitShopifyCheckout);

        if (is_advisor_product && is_advisor) {
            cartAttributes["Advisor ID"] = localStorage.getItem('Advisor ID') || '-';
            cartAttributes["Advisor Name"] = localStorage.getItem('Advisor Name') || '-';
            cartAttributes["Previous Demo Experience?"] = $('.demo-radio:checked').val() || '-';
            cartAttributes["Would you like to select a preferred advisor?"] = $('.interested-advisor-radio:checked').val() || '-';
        } else {
            // For non-advisor products, clear advisor data from cart attributes only
            // Keep localStorage intact so advisor data can be restored later
            cartAttributes["Advisor ID"] = '-';
            cartAttributes["Advisor Name"] = '-';
            cartAttributes["Previous Demo Experience?"] = '-';
            cartAttributes["Would you like to select a preferred advisor?"] = '-';
        }
        if (containsMainProduct === true || containsMainProduct === 'true') {
            cartAttributes["Main Product"] = "Yes";
        } else {
            cartAttributes["Main Product"] = "No";
        }

        // customer info cart attributes
        if (window.theme.customerInfo && window.theme.customerInfo.name != 'Guest') {
            cartAttributes["Customer Name"] = window.theme.customerInfo.name;
            cartAttributes["Customer Email"] = window.theme.customerInfo.email;
            cartAttributes["Customer Address"] = window.theme.customerInfo.address;
            cartAttributes["Customer Postal Code"] = window.theme.customerInfo.postalCode;
            cartAttributes["Customer City"] = window.theme.customerInfo.city;
            cartAttributes["Customer Phone"] = window.theme.customerInfo.phone;
            cartAttributes["Home Phone"] = window.theme.customerInfo.homeNumber;
            cartAttributes["Sales Unit"] = "";
        } else {
            cartAttributes["Customer Name"] = 'Guest';
            cartAttributes["Customer Email"] = '';
            cartAttributes["Customer Address"] = '';
            cartAttributes["Customer Postal Code"] = '';
            cartAttributes["Customer City"] = '';
            cartAttributes["Customer Phone"] = '';
            cartAttributes["Home Phone"] = '';
            cartAttributes["Sales Unit"] = '';
        }

        if (!isTaxInvoiceEnabled) {
            cartAttributes["Tax Invoice for Legal Compliance"] = "";
            cartAttributes["Company Name"] = "";
            cartAttributes["Company Registration No"] = "";
            cartAttributes["Mobile Carrier No"] = "";
            cartAttributes["Tax Policy"] = "";
        }

        try {
            if (Object.keys(cartAttributes).length > 0) {
                CartJS.setAttributes(cartAttributes);
            } else {
                submitShopifyCheckout();
            }
        } catch (error) {
            console.error('Unable to save cart attributes before checkout:', error);
            submitShopifyCheckout();
        }
    } else {
        console.log('checkout not valid, please check the checkout function condition.');
        $loader.hide();
    }
};

// start: split payment button
const splitPayment = async (is_advisor_product, is_advisor) => {
    var $loader = $('.jsc-loader-overlay');
    let cartAttributes = {};
    const isTaxInvoiceEnabled = $('#CartPageForm').data('tax-invoice-enabled');
    const containsMainProduct = $('#CartPageForm').data('contains-main-product');

    // if (!isCustomerLoggedIn()) {
    //     showLoginRequiredPrompt();
    //     return false;
    // }

    $loader.show();

    let redirectButton = $('.shopify-checkout-btn')
    if ($('.spp2__button-container .spp2__payment-button').length > 0) {
        redirectButton = $('.spp2__button-container .spp2__payment-button');
    }
    console.log('redirectButton: ', redirectButton);

    // Split payment must click the SPP button, not navigate to /checkout.
    const completeSplitPayment = () => {
        clearCheckoutRequest();
        $loader.hide();
        redirectButton.click();
    };

    if (is_advisor_product && is_advisor) {
        let isValid = true;
        const demoVal = $('.demo-radio:checked').val();

        if (demoVal === undefined) {
            $loader.hide();
            $('#jsc-advisor-error-msg').show();
            isValid = false;
        } else {
            if (demoVal === 'Yes') {
                const advisorIdValue = $('#search-advisor').val();
                localStorage.setItem('Advisor ID', advisorIdValue);
                $('#jsc-advisor-error-msg').hide();
            } else {
                const interestedAdvisor = $('.interested-advisor-radio:checked').val();
                if (interestedAdvisor === undefined) {
                    isValid = false;
                    $('#jsc-advisor-error-msg').show();
                } else {
                    if (interestedAdvisor === 'Yes') {
                        const advisorIdValue = $('#search-advisor').val();
                        localStorage.setItem('Advisor ID', advisorIdValue);
                        $('#jsc-advisor-error-msg').hide();
                    }
                }
            }
        }

        if (!$('#CartTerms').is(':checked')) {
            $loader.hide();
            showGenericAlert("You must agree with the terms and conditions of sales.")
            isValid = false;
        }

        if (isTaxInvoiceEnabled) {
            const saveResult = await saveCartAttr();
            $loader.show();
            if (saveResult === false) {
                isValid = false;
            }
        }

        if (isValid && isTaxInvoiceEnabled) {
            const addedTaxInvoiceInfo = await addTaxInvoiceInfoAtLineItemProperties();
            if (!addedTaxInvoiceInfo) isValid = false;
        }

        if (isValid) {
            $loader.hide();
            const addedAdvisorInfo = await addAdvisorInfoAtLineItemProperties();
            if (addedAdvisorInfo) {
                cartAttributes["Advisor ID"] = localStorage.getItem('Advisor ID') || '-';
                cartAttributes["Advisor Name"] = localStorage.getItem('Advisor Name') || '-';
                cartAttributes["Previous Demo Experience?"] = $('.demo-radio:checked').val() || '-';
                cartAttributes["Would you like to select a preferred advisor?"] = $('.interested-advisor-radio:checked').val() || '-';

                if (containsMainProduct === true || containsMainProduct === 'true') {
                    cartAttributes["Main Product"] = "Yes";
                } else {
                    cartAttributes["Main Product"] = "No";
                }

                // customer info cart attributes
                if (window.theme.customerInfo && window.theme.customerInfo.name != 'Guest') {
                    cartAttributes["Customer Name"] = window.theme.customerInfo.name;
                    cartAttributes["Customer Email"] = window.theme.customerInfo.email;
                    cartAttributes["Customer Address"] = window.theme.customerInfo.address;
                    cartAttributes["Customer Postal Code"] = window.theme.customerInfo.postalCode;
                    cartAttributes["Customer City"] = window.theme.customerInfo.city;
                    cartAttributes["Customer Phone"] = window.theme.customerInfo.phone;
                    cartAttributes["Home Phone"] = window.theme.customerInfo.homeNumber;
                    cartAttributes["Sales Unit"] = "";
                } else {
                    cartAttributes["Customer Name"] = 'Guest';
                    cartAttributes["Customer Email"] = '';
                    cartAttributes["Customer Address"] = '';
                    cartAttributes["Customer Postal Code"] = '';
                    cartAttributes["Customer City"] = '';
                    cartAttributes["Customer Phone"] = '';
                    cartAttributes["Home Phone"] = '';
                    cartAttributes["Sales Unit"] = '';
                }

                if (!isTaxInvoiceEnabled) {
                    cartAttributes["Tax Invoice for Legal Compliance"] = "";
                    cartAttributes["Company Name"] = "";
                    cartAttributes["Company Registration No"] = "";
                    cartAttributes["Mobile Carrier No"] = "";
                    cartAttributes["Tax Policy"] = "";
                }

                bindCheckoutRequestComplete(completeSplitPayment);

                try {
                    if (Object.keys(cartAttributes).length > 0) {
                        CartJS.setAttributes(cartAttributes);
                    } else {
                        completeSplitPayment();
                    }
                } catch (error) {
                    console.error('Unable to save cart attributes before checkout:', error);
                    completeSplitPayment();
                }
            }
        } else {
            $loader.hide();
        }
    } else {
        console.log('spli-payment button not contain advisor product.');
        if (!$('#CartTerms').is(':checked')) {
            $loader.hide();
            showGenericAlert("You must agree with the terms and conditions of sales.");
        } else {
            // For non-advisor products, clear advisor data from cart attributes only
            // Keep localStorage intact so advisor data can be restored later
            cartAttributes["Advisor ID"] = '-';
            cartAttributes["Advisor Name"] = '-'
            cartAttributes["Previous Demo Experience?"] = $('.demo-radio:checked').val() || '-';
            cartAttributes["Would you like to select a preferred advisor?"] = $('.interested-advisor-radio:checked').val() || '-';

            bindCheckoutRequestComplete(completeSplitPayment);

            try {
                if (Object.keys(cartAttributes).length > 0) {
                    CartJS.setAttributes(cartAttributes);
                } else {
                    completeSplitPayment();
                }
            } catch (error) {
                console.error('Unable to save cart attributes before checkout:', error);
                completeSplitPayment();
            }
        }
    }
};
// end: split payment button

/**
 * Fetches advisor data from an external API.
 */
const fetchAdvisorJson = () => {
    const url = $('#advisor_json').val();
    fetch(url)
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(json => {
            console.log(json);
            onSearchAdvisor(json);
        })
        .catch(error => {
            $('#advisor-search-results').append(`<div class="advisor-not-found hide">Fetch error: ${error}</div>`);
            console.error('Fetch error:', error);
        });
};

/**
 * Handles the search functionality for advisors based on user input.
 * @param {Object} consultants - The list of consultants fetched from the API.
 */
const onSearchAdvisor = (consultants) => {
    $(document).on('keyup', '#search-advisor', function() {
        $('#jsc-advisor-error-msg').hide();
        const query = $(this).val().toLowerCase();
        const alphanumericRegex = /^[a-z0-9]+$/i;

        if (query !== '' && alphanumericRegex.test(query)) {
            const filteredConsultants = consultants.consultantMy.filter(consultant => {
                const consultantId = consultant["consultant'sId"].toString();
                const consultantName = consultant["consultant'sName"].toLowerCase();
                return consultantId.includes(query) || consultantName.includes(query);
            });

            $('#advisor-search-results').empty();
            if (filteredConsultants.length > 0) {
                filteredConsultants.forEach(consultant => {
                    const resultHtml = `
                        <div class="padding-10 advisor-row cursor" onclick="selectAdvisor(this, '${consultant["consultant'sId"]}')"> 
                            <span class="cursor">Consultant ID: <b>${consultant["consultant'sId"]}</b></span><br>
                            <span class="cursor">Consultant Name: <b>${consultant["consultant'sName"]}</b></span>
                        </div>`;
                    $('#advisor-search-results').append(resultHtml);
                });
            } else {
                $('#advisor-search-results').append('<div class="advisor-not-found">No matching advisor found.</div>');
            }
        } else {
            $('#advisor-search-results').empty();
        }
    });
};

/**
 * Selects an advisor from the search results and updates the input field.
 * @param {HTMLElement} e - The clicked element representing the selected advisor.
 * @param {string} id - The ID of the selected advisor.
 */
const selectAdvisor = (e, id) => {
    $('#advisor-search-results').empty();
    $('#search-advisor').val(id);
    localStorage.setItem('Advisor ID', id);
};

/**
 * Retrieves advisor-related information from local storage and updates the UI accordingly.
 */
const getAdvisorLocalStorage = () => {
    const demoValue = localStorage.getItem('Previous Demo Experience?');
    const interestedValue = localStorage.getItem('Would you like to select a preferred advisor?');
    const is_demo = demoValue ? demoValue.toLowerCase().trim() : (demoValue || '');
    const is_interested = interestedValue ? interestedValue.toLowerCase() : interestedValue;
    const advisor_id = localStorage.getItem('Advisor ID');
    const refId = localStorage.getItem('Referral ID');
    
    if (is_demo === "yes" || (is_demo !== 'yes' && refId !== null && refId !== undefined && refId !== '' && refId !== '-')) {
        $(`#demo-yes`).prop('checked', true).trigger('change', [{ resetInterestedAdvisorValue: false }]);
        if (advisor_id) {
            $('#search-advisor').val(advisor_id);
            localStorage.setItem('Advisor ID', advisor_id);
        }
        if ($('.jsc-advisor-select').hasClass('d-none')) {
            $('.jsc-advisor-select').removeClass('d-none');
        }
    } else if (is_demo === 'no') {
        $(`#demo-no`).prop('checked', true).trigger('change', [{ resetInterestedAdvisorValue: true }]);

        if (is_interested === 'yes') {
            $(`#interested-advisor-yes`).prop('checked', true).trigger('change');
            if (advisor_id) {
                $('#search-advisor').val(advisor_id);
                localStorage.setItem('Advisor ID', advisor_id);
            }
        } else {
            if (!$('.jsc-advisor-select').hasClass('d-none')) {
                $('.jsc-advisor-select').addClass('d-none');
                $('#jsc-cart-advisor-name-input').val('-');
            }
            if ($(`#interested-advisor-no`).length) $(`#interested-advisor-no`).prop('checked', true);
        }
    } else {
        // Do not auto-select: leave both Previous Demo Experience? radios unselected (first visit or returned from advisor)
        $('.demo-radio').prop('checked', false);
        $('.jsc-interested-advisor').remove();
        $('.jsc-advisor').remove();
        if ($('.jsc-advisor-select').length && !$('.jsc-advisor-select').hasClass('d-none')) {
            $('.jsc-advisor-select').addClass('d-none');
            $('#jsc-cart-advisor-name-input').val('-');
        }
    }
};

// Scripts for Advisor feature ends here

// start: Product image - Gallery modal
initGalleryModal = (modal, _this, mainSliderArgs, productId, Slideshow) => {
    console.log('initGalleryModal');
    var tabs = modal.querySelectorAll('[data-tab]');
    const mainThumbnail = modal.querySelector(`#ProductThumbnail-gallery-media-modal-section`);
    const mainFlickity = modal.querySelector(`#ProductPhotos-gallery-media-modal-section`);
    if (localStorage.getItem('productId') !== productId) {
        if (mainThumbnail) {
            const clonedThumbnail = mainThumbnail.cloneNode(true);
            localStorage.setItem('clonedThumbnail', clonedThumbnail.outerHTML);
        }
        if (mainFlickity) {
            const clonedFlickity = mainFlickity.cloneNode(true);
            localStorage.setItem('clonedFlickity', clonedFlickity.outerHTML);
        }
        localStorage.setItem('productId', productId);
    }

    // init gallery modal tab
    if (tabs) {
        tabs.forEach(tab => {
            tab.addEventListener('click', function(event) {
                const tabName = event.currentTarget.getAttribute('data-tab');

                /* start: active tab color */
                tabs.forEach(sibling => {
                    sibling.classList.remove('is-active');
                });

                tab.classList.add('is-active');
                /* end: active tab color */

                /* start: destroy flickity */
                if (_this.flickity && typeof _this.flickity.destroy === 'function') {
                    _this.flickity.destroy();
                    console.log('flickity destroy');
                }
                /* end: destroy flickity */

                /* start: clone thumbnail flickity */
                var thumbnailFlickity = modal.querySelector(`#ProductThumbnail-gallery-media-modal-section`);

                if (thumbnailFlickity) {
                    clonedFlickity('clonedThumbnail', tabName, 'product__thumb-item', thumbnailFlickity, _this, mainSliderArgs);
                }
                /* end: clone thumbnail media flickity */

                /* start: clone main product media flickity */
                var galleryModalFlickity = modal.querySelector(`#ProductPhotos-gallery-media-modal-section`);

                if (galleryModalFlickity) {
                    clonedFlickity('clonedFlickity', tabName, 'product-main-slide', galleryModalFlickity, _this, mainSliderArgs, Slideshow);
                }
                /* end: clone main product media flickity */
            })
        })
    }
}
// end: Product image - Gallery modal


clonedFlickity = (name, tabName, slideClass, flickityElement, _this, mainSliderArgs, Slideshow=null) => {
    console.log('clonedFlickity: ', name);
    const storedElementHTML = localStorage.getItem(name);
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = storedElementHTML;
    const retrievedElement = tempDiv.firstChild;
    retrievedElement.classList.add(name);

    const slideElement = retrievedElement.querySelectorAll(`.${slideClass}`);

    let currentThumbnailIndex = -1;
    slideElement.forEach(function(slide, index) {
        if (tabName == 'image' && slide.dataset.mediaType !== 'image') {
            slide.remove();
        } else if (tabName == 'video' && slide.dataset.mediaType !== 'video'){
            slide.remove();
        } else if (name == 'clonedThumbnail') {
            currentThumbnailIndex += 1
            slide.setAttribute('data-index', currentThumbnailIndex);
        }
    })

    flickityElement.parentNode.insertBefore(retrievedElement, flickityElement);
    flickityElement.remove();
    retrievedElement.classList.remove(name);

    if (mainSliderArgs) {
        if (name == 'clonedThumbnail') {
            mainSliderArgs.childNav = retrievedElement
        } else if (name == 'clonedFlickity' && Slideshow != null) {
            _this.flickity = new Slideshow(retrievedElement, mainSliderArgs);
            setTimeout(() => {
                _this.flickity.resize()
            }, 100)
            _this.initImageZoom();
        }
    }
}

setSliderEqualHeight = (blockId) => {
    console.log('setSliderEqualHeight - blockId: ', blockId);

    if (!blockId) {
        console.warn('setSliderEqualHeight: blockId is required');
        return;
    }

    const sectionClass = 'section--' + blockId;
    const $slider = $(`.${sectionClass}.text-columns--slider`);
    if (!$slider.length) return;

    const $slides = $slider.find('.flickity-cell');
    const $flickityViewport = $slider.find('.flickity-viewport');
    if (!$slides.length) return;

    let maxHeight = 0;

    // Reset heights
    $slides.css('height', 'auto');

    // Calculate tallest height (only if visible)
    $slides.each(function() {
        const $slide = $(this);
        if ($slide.is(':visible')) {
            const height = $slide.outerHeight();
            if (height > maxHeight) maxHeight = height;
        }
    });

    // If slider still hidden (height=0), retry after short delay
    if (maxHeight === 0) {
        setTimeout(() => setSliderEqualHeight(blockId), 50);
        return;
    }

    // Apply equal height (+5px buffer)
    $slides.css('height', `${maxHeight + 5}px`);
    $flickityViewport.css('height', `${maxHeight + 5}px`);
}

initTextColumnsFlickity = () => {
    console.log('initTextColumnsFlickity');

    $('.text-columns__flickity-slider').each(function() {
        const $slider = $(this);
        const setEqualHeight = $slider.data('set-equal-height') === true || $slider.data('set-equal-height') === 'true';
        const blockId = $slider.data('block-id') || "";
        const isAdaptiveHeight = !(setEqualHeight && blockId != "")

        console.log('isAdaptiveHeight: ', isAdaptiveHeight);
        console.log('setEqualHeight: ', setEqualHeight);
        console.log('blockId: ', blockId);

        // Initialize Flickity
        const flkty = $slider.flickity({
            cellAlign: 'left',
            freeScroll: true,
            wrapAround: true,
            adaptiveHeight: isAdaptiveHeight,
            prevNextButtons: true,
            pageDots: true,
            resize: true
        });

        setTimeout(() => {
            flkty.resize();
            if (setEqualHeight && blockId) {
                setSliderEqualHeight(blockId);
            }
        }, 100);

        // Recalculate equal heights on window resize
        if (setEqualHeight && blockId) {
            $(window).on('resize orientationchange', () => {
                setSliderEqualHeight(blockId);
            });
        }
    });
}
// Start of Storepoint customisation
bindFunction = () =>{
    $('.stpt-marker').attr('onclick', 'triggerMapPopup()');
    $('.storepoint-location').attr('onclick', 'triggerMapPopup()');
    if ($('#storepoint-container').length) {
        var $loader = $('.jsc-loader-overlay');
        $loader.hide();
    }
}

eventListnerTriggerPopup = () =>{
    $('body').on('click', '.storepoint-location, .stpt-marker', function() {
        triggerMapPopup();
    });
    $('.mapboxgl-ctrl-geocoder--input').on('keydown', function(event) {
        if (event.key === 'Enter') {
            triggerMapPopup();
        }
    });
}
triggerMapPopup = () =>{
    setTimeout(() => {
        $('.street-address').insertBefore($('.storepoint-popup-description'));
    
        var languages = [];
        var _id = '';
        var _location;
        $('.tag-text').each(function(){
            var _this = $(this);
            var text = _this.text();

            _location = _this;
            
            if (text.includes('id_') || text.includes('Id_')) {
                _this.parents('span.tag').hide();
                _id = text.split('_')[1];
            } else if (text.includes('food_') || text.includes('Food_')) {
                _this.text(text.split('_')[1]);
            } else if (text.includes('language_') || text.includes('Language_')) {
                var language = text.split('_')[1];
                languages.push(language);
                _this.parents('span.tag').hide();
            }
        });

        var uniqueLanguanges = Array.from(new Set(languages));
        var html = `<div class="jsc-language text-left m-b-10 hide">`;
        uniqueLanguanges.forEach(element => {
            html += `<span class="uppercase m-r-5">${element}</span>`
        });
        html += `</div>`;
        
        
        if (!_location.parents('.storepoint-location-popup').find('.jsc-language').length) {
            _location.parents('.storepoint-location-popup').prepend(html);
        }
        if (!$(`.tag-id_${_id}`).parents('.storepoint-location').find('.jsc-language').length) {
            $(`.tag-id_${_id}`).parents('.storepoint-location').prepend(html);
        }
        
        var current_name = _location.parents('.storepoint-location-popup').find('b').text();
        var current_id = localStorage.getItem('Advisor ID');
        var selectAdvisorBtn = `<button class="btn no-border full-width jsc-select-btn" onclick="selectMapAdvisor(this, '${_id}', '${current_name}')" ${ current_id == _id ? 'disabled' : ''}>${ current_id == _id ? 'Selected' : 'Select'}</button>`;

        if(current_id == _id ) {
            $('.jsc-select-btn').attr('disabled','disabled').text('Selected');
        }
        
        // if (!_location.parents('.storepoint-location-popup').siblings('.jsc-select-btn').length) {
        //     $(selectAdvisorBtn).insertBefore($('.mapboxgl-popup-close-button'));
        // }
        
    }, 60);
}

selectMapAdvisor = (e, id, name, profileImg) =>{
    // Use updateAdvisorData function to handle all advisor data updates
    const profilePicture = (!profileImg || profileImg === '-') ? '' : profileImg;
    updateAdvisorData(id, name, profilePicture, false);

    // Update button state
    $(e).prop('disabled', true).text('Selected');
    console.log('ppokee', getUrlParameter('advisor'));

    if (getUrlParameter('advisor') == 'cart') {
        $(document).on('cart.requestComplete', function(event, cart) {
            location.href = `/cart`;
        });
    } else {
        $(document).on('cart.requestComplete', function(event, cart) {
            if (id && id !== '-') {
                location.href = `/pages/storepoint-my/id_${id}`;
            } else {
                location.href = `/`;
            }
        });
    }
    
    var storepointID = window.location.href.split('selected=')[1];
    //console.log('storepointID 1',storepointID);
    localStorage.setItem('Advisor Storepoint ID', storepointID);
}

getUrlParameter = (name) =>{
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// End of Storepoint customisation


// start: pdpa function
// track bank account name checkbox
$('#bank_account_name_checkbox').on('change', function() {
    if ($(this).prop('checked')) {
        var full_name = $('#full_name').val();
        if (full_name != '') {
            $('#bank_account_name').val(full_name);
            $('#bank_account_name').addClass('jsc-disable-field');
            $('#bank_account_name_checkbox_error').css('display', 'none');
        } else {
            $('#bank_account_name_checkbox_error').css('display', 'block');
        }
    } else {
        $('#bank_account_name').removeClass('jsc-disable-field');
        $('#bank_account_name_checkbox_error').css('display', 'none');
    }
});
// track address state
$('#address_state').on('change', function() {
    const selectedStateName = $(this).val();
    $(this).attr('data-default', selectedStateName);
})
// track mobile number
$('#jsc-telephone').on('focus', function() {
    $phoneInput = $('#jsc-telephone');
    let value = $phoneInput.val();

      if (value.startsWith('+60')) {
        $phoneInput.val('+60' + value.slice(3).replace(/\D/g, ''));
      } else {
        $phoneInput.val('+60');
      }
});
// track full name
$('#full_name').on('input', function() {
    if ($('#bank_account_name_checkbox').prop('checked')) {
        var full_name_val = $('#full_name').val();
        $('#bank_account_name').val(full_name_val);
    }
});
// track postal code
$('#postal_code').on('input', function() {
    $postal_code = $('#postal_code');

    if ($postal_code.val().length > 5) {
        $postal_code.val($postal_code.val().slice(0, 5));
    }
});
/* intl-tel-input library: https://intl-tel-input.com/examples/validation.html */
initIntlTelInput = () => {
    const input = document.querySelector("#register_mobile");
    // initialise plugin
    intlTelInstance['iti'] = window.intlTelInput(input, {
        initialCountry: "my",
        loadUtilsOnInit: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.7.0/build/js/utils.js",
        separateDialCode: true, // Display country code separately
        nationalMode: false,    // Use full international number format
    });
    console.log('intlTelInstance: ', intlTelInstance);
}
fetchNationality = () => {
    fetch('https://cdn.shopify.com/s/files/1/0898/5218/2810/files/jsc-nationality-list.json')
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(nationalities => {
            // console.log(nationalities);
            if (nationalities.length > 0) {
                $.each(nationalities, function(index, item) {
                    const listItem = $('<option></option>').text(item.Nationality).val(item.Nationality);
                    const nationalityData = $('#nationality').attr('data-default') ? $('#nationality').attr('data-default').toLowerCase() : $('#nationality').attr('data-default');
                    if (item.Nationality && item.Nationality.toLowerCase() === nationalityData) {
                        listItem.prop('selected', true);
                    }
                    $('#nationality').append(listItem);
                });
            }
        })
        .catch(error => {
            console.error('Fetch nationality error:', error);
        });
}
fetchMYBankList = () => {
    fetch('https://cdn.shopify.com/s/files/1/0898/5218/2810/files/jsc-my-bank-list.json')
        .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
        })
        .then(availableBank => {
            // console.log(availableBank);
            if (availableBank.length > 0) {
                $.each(availableBank, function(index, bank) {
                    const listItem = $('<option></option>').text(bank['Reporting Institutions']).val(bank['Reporting Institutions']);
                    const bankData = $('#bank_name').attr('data-default') ? $('#bank_name').attr('data-default').toLowerCase() : $('#bank_name').attr('data-default');
                    if (bank['Reporting Institutions'] && bank['Reporting Institutions'].toLowerCase() === bankData) {
                        listItem.prop('selected', true);
                    }
                    $('#bank_name').append(listItem);
                });
            }
        })
        .catch(error => {
            console.error('Fetch nationality error:', error);
        });
}
updateCountryState = () => {
    var defaultProvince = $('#address_state').attr('data-default')
    $('#address_state').val(defaultProvince);
}
enableAccountUpdateWhenFoundChanges = () =>{
    fetchNationality();
    fetchMYBankList();
    // Get the input elements
    // accept marketing input: #accepts_marketing_email, #accepts_marketing_sms, #accepts_marketing_post, #accepts_marketing_telephone,
    var accountPagePdpaInputs = $("#alias, #email, #full_name, #nric, #nationality, #register_mobile, #register_home, #postal_code, #address_state, #address_city, #address_1, #address_2, #bank_name, #bank_account_name, #bank_account_name_checkbox, #bank_account_number, #accepts_policy");

    // Get the submit button
    var updatePdpaButton = $("#update-profile");

    if ($('#bank_account_name_checkbox').prop('checked')) {
        var full_name = $('#full_name').val();
        if (full_name != '') {
            $('#bank_account_name').val(full_name);
            $('#bank_account_name').addClass('jsc-disable-field');
        } else {
            $('#bank_account_name_checkbox').prop('checked', false);
        }
    }

    // Store the initial values
    var initialValues = {};
    accountPagePdpaInputs.each(function () {
      if ($(this).is(":checkbox")) {
        initialValues[this.id] = $(this).prop("checked");
      } else {
        initialValues[this.id] = $(this).val();
      }
    });

    // Add event listener to all input fields
    accountPagePdpaInputs.on("input change", function () {
      var allValuesMatch = accountPagePdpaInputs.toArray().every(function (input) {
        if ($(input).is(":checkbox")) {
          // For checkboxes, check the "checked" property
          return $(input).prop("checked") === initialValues[input.id];
        } else {
          // For other input types, check the "value" property
          return $(input).val() === initialValues[input.id];
        }
      });

      // Enable or disable the submit button based on whether any values have changed
      updatePdpaButton.prop("disabled", allValuesMatch);
    });
}
customerInfoValidation = ($email, $full_name, $nationality, $register_mobile, $register_home) => {
    var $passValidation = true;
    if ($email == '') {
        $('#email_error').show();
        $passValidation = false;
    } else {
        $('#email_error').hide();
        if ($email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
            $('#email_format_error').hide();
        } else {
            $('#email_format_error').show();
            $passValidation = false;
        }
    }

    if ($full_name == '') {
        $('#full_name_error').show();
        $passValidation = false;
    } else {
        $('#full_name_error').hide();
    }

    if ($nationality == '') {
        $('#nationality_error').show();
        $passValidation = false;
    } else {
        $('#nationality_error').hide();
    }

    console.log('$register_mobile: ', $register_mobile.trim());
    console.log('getSelectedCountryData(): ', intlTelInstance['iti'].getSelectedCountryData());
    console.log('isValidNumberPrecise: ', intlTelInstance['iti'].isValidNumberPrecise());

    if ($register_mobile.trim() == '') {
        $('#register_mobile_error').show();
        $passValidation = false;
    } else {
        $('#register_mobile_error').hide();
        if (intlTelInstance['iti'].isValidNumberPrecise()) {
            $('#register_mobile_format_error').hide();
        } else {
            $('#register_mobile_format_error').show();
            $passValidation = false;
        }
    }

    // if ($register_home == '') {
    //     $('#register_home_error').show();
    //     $passValidation = false;
    // } else {
    //     $('#register_home_error').hide();
    // }

    return $passValidation;
}
addressValidation = ($address_1, $address_city, $address_state, $postal_code) => {
    var $passValidation = true;
    if ($address_1 == '') {
        $('#address_1_error').show();
        $passValidation = false;
    } else {
        $('#address_1_error').hide();
    }

    if ($address_city == '') {
        $('#address_city_error').show();
        $passValidation = false;
    } else {
        $('#address_city_error').hide();
    }

    if ($address_state == '') {
        $('#address_state_error').show();
        $passValidation = false;
    } else {
        $('#address_state_error').hide();
    }

    if ($postal_code == ''){
        $('#postal_code_error').show();
        $passValidation = false;
    } else {
        $('#postal_code_error').hide();
        // https://gist.githubusercontent.com/jamesbar2/1c677c22df8f21e869cca7e439fc3f5b/raw/21662445653ac861f8ab81caa8cfaee3185aed15/postal-codes.json (postal code regex)
        if ($postal_code.match(/^\d{5}$/)) {
            $('#postal_code_format_error').hide();
        } else {
            $('#postal_code_format_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
bankValidation = ($bank_name, $bank_account_name, $bank_account_number) => {
    var $passValidation = true;
    if ($bank_name == '') {
        $('#bank_name_error').show();
        $passValidation = false;
    } else {
        $('#bank_name_error').hide();
    }

    if ($bank_account_name == '') {
        $('#bank_account_name_error').show();
        $passValidation = false;
    } else {
        $('#bank_account_name_error').hide();
    }

    if ($bank_account_number == '') {
        $('#bank_account_number_error').show();
        $passValidation = false;
    } else {
        $('#bank_account_number_error').hide();
        if ($bank_account_number.length >=8 && $bank_account_number.length <=17) {
            $('#bank_account_number_format_error').hide();
        } else {
            $('#bank_account_number_format_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
acceptsMarketingValidation = ($accepts_marketing_email, $accepts_marketing_sms, $accepts_marketing_post, $accepts_marketing_telephone) => {
    var $passValidation = true;
    var show_accepts_marketing_error = true;
    if ($accepts_marketing_email || $accepts_marketing_sms || $accepts_marketing_post || $accepts_marketing_telephone) {
        show_accepts_marketing_error = false
    }
    if (show_accepts_marketing_error) {
        $('#accepts_marketing_error').show();
        $passValidation = false;
    } else {
        $('#accepts_marketing_error').hide();
    }

    console.log('accepts_marketing_sms: ', $accepts_marketing_sms);
    if ($accepts_marketing_sms) {
        if (intlTelInstance['iti'].isValidNumberPrecise()) {
            $('#accepts_marketing_sms_error').hide();
        } else {
            $('#accepts_marketing_sms_error').show();
            $passValidation = false;
        }
    }

    return $passValidation;
}
advisorCustomerAPI = (id, em, advid, recid, recn, fn, nt, mo, ho, add, add2, city, st, pc, ctry, nob, accn, accnum, lang, spec, alias, sendEmail, mce, mcs, mct) =>{
    // accepts marketing params: mce, mcs, mcp, mct
    let $data = {
        id: id,
        advisor_id: advid,
        last_name: fn,
        address: add,
        address2: add2,
        city: city,
        state: st,
        country: ctry,
        postal_code: pc,
        email: em,
        mobile: mo,
        home: ho,
        nationality: nt,
        bank_name: nob,
        bank_account_name: accn,
        bank_account_number: accnum,
        recruiter_id: recid,
        recruiter_name: recn,
        language: lang,
        specialities: spec,
        alias: alias,
        send_email: sendEmail,
        email_marketing_consent: mce,
        sms_marketing_consent: mcs,
        tel_marketing_consent: mct
    };
    // email_marketing_consent: mce,
    // sms_marketing_consent: mcs,
    // post_marketing_consent: mcp,
    // tel_marketing_consent: mct,

    $.ajax({
        url: "https://webhooks.mechanic.dev/f99a12f7-66e3-498c-8003-1fb3c13a1c56", //user/custom/update_advisor
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data)
    });
}
customerAPI = (id, add, add2, city, st, pc, ctry) => {
    let $data = {
        id: id,
        address: add,
        address2: add2,
        city: city,
        state: st,
        country: ctry,
        postal_code: pc
    };

    $.ajax({
        url: "https://webhooks.mechanic.dev/a6d06934-b946-4b06-a843-96d969558462", //user/custom/update
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data)
    });
}
updatePdpaAdvisor = (evt,is_tm4u) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $shopifyId = parseInt($('#jsc-customer-id').val());

    var $full_name = $('#full_name').val();
    var $nric = $('#nric').val();
    var $nationality = $('#nationality').val();
    var $register_mobile = $('#register_mobile').val();
    var $register_home = $('#register_home').val();

    var $address_1 = $('#address_1').val();
    var $address_2 = $('#address_2').val();
    var $address_city = $('#address_city').val();
    var $address_state = $('#address_state').val();
    var $postal_code = $('#postal_code').val();
    var $address_country_code = $('#address_country_code').val();

    var $bank_name = $('#bank_name').val();
    var $bank_account_name = $('#bank_account_name').val();
    var $bank_account_number = $('#bank_account_number').val();

    var $alias = $('#alias').val();
    var $advisor_language = $('#language_label').text().replace('Language', '');
    var $advisor_specialities = $('#specialities_label').text().replace('Specialities', '');

    // var $accepts_marketing_email = $('#accepts_marketing_email').prop("checked");
    // var $accepts_marketing_sms = $('#accepts_marketing_sms').prop("checked");
    // var $accepts_marketing_post = $('#accepts_marketing_post').prop("checked");
    // var $accepts_marketing_telephone = $('#accepts_marketing_telephone').prop("checked");

    var $accepts_policy = $('#accepts_policy').prop("checked");

    var $email = $('#email').val();
    var $advisor_id = $('#advisor_id').val();
    var $recruiter_id = $('#recruiter_id').val();
    var $recruiter_name = $('#recruiter_name').val();

    var $isvalidatedCustomerInfo = customerInfoValidation($email, $full_name, $nationality, $register_mobile, $register_home);
    var $isvalidatedAddress = addressValidation($address_1, $address_city, $address_state, $postal_code);
    var $isvalidatedBank = bankValidation($bank_name, $bank_account_name, $bank_account_number);
    // var $isvalidatedAcceptsMarketing = acceptsMarketingValidation($accepts_marketing_email, $accepts_marketing_sms, $accepts_marketing_post, $accepts_marketing_telephone);

    var $isvalidatedAcceptsCondition = true;
    if (!$accepts_policy) {
        $('#accepts_policy_error').show();
        $isvalidatedAcceptsCondition = false;
    } else {
        $('#accepts_policy_error').hide();
    }

    var $isvalidatedAdvisorLanguage = true;
    if (!is_tm4u) {
        if ($advisor_language == '') {
            $isvalidatedAdvisorLanguage = false;
            $('#language_blank_error').show();
        } else {
            $('#language_blank_error').hide();
            $('#language_error').hide();
        }
    }

    var $isvalidatedAdvisorSpecialities = true;
    if (!is_tm4u) {
        if ($advisor_specialities == '') {
            $isvalidatedAdvisorSpecialities = false;
            $('#specialities_blank_error').show();
        } else {
            $('#specialities_blank_error').hide();
            $('#specialities_error').hide();
        }
    }

    var $send_update_email = true;
    var $email_marketing_channel = '';
    var $sms_marketing_channel = '';
    var $tel_marketing_channel = '';
    var $isvalidatedAcceptsMarketing = true;

    if (is_tm4u) {
        $send_update_email = false;
        var $email_marketing_channel = $('#marketing_channel_email').prop("checked").toString().toLowerCase();
        var $sms_marketing_channel = $('#marketing_channel_sms').prop("checked").toString().toLowerCase();
        var $tel_marketing_channel = $('#marketing_channel_telephone').prop("checked").toString().toLowerCase();
        if ($sms_marketing_channel == 'false') {
            $isvalidatedAcceptsMarketing = false;
        }
    }
    if (!$isvalidatedAcceptsMarketing) {
        $('#accepts_marketing_error').show();
    } else {
        $('#accepts_marketing_error').hide();
    }

    console.log('isvalidatedCustomerInfo: ', $isvalidatedCustomerInfo);
    console.log('isvalidatedAddress: ', $isvalidatedAddress);
    console.log('isvalidatedBank: ', $isvalidatedBank);
    console.log('isvalidatedAdvisorLanguage: ', $isvalidatedAdvisorLanguage);
    console.log('isvalidatedAdvisorSpecialities: ', $isvalidatedAdvisorSpecialities);
    console.log('isvalidatedAcceptsMarketing: ', $isvalidatedAcceptsMarketing);

    if ($isvalidatedCustomerInfo && $isvalidatedAddress && $isvalidatedBank && $isvalidatedAcceptsCondition && $isvalidatedAdvisorLanguage && $isvalidatedAdvisorSpecialities && $isvalidatedAcceptsMarketing) {
        console.log('$email_marketing_channel: ', $email_marketing_channel);
        console.log('$sms_marketing_channel: ', $sms_marketing_channel);
        console.log('$tel_marketing_channel: ', $tel_marketing_channel);
        // accept marketing params: $accepts_marketing_email, $accepts_marketing_sms, $accepts_marketing_post, $accepts_marketing_telephone

        const intlTelCountryData = intlTelInstance['iti'].getSelectedCountryData();
        const dialCode = `+${intlTelCountryData.dialCode}`;

        if (!$register_mobile.includes(dialCode)) {
            $register_mobile = `+${intlTelCountryData.dialCode}${$register_mobile}`;
            console.log('$register_mobile added dial code: ', $register_mobile);
        }

        advisorCustomerAPI($shopifyId,
            $email, $advisor_id, $recruiter_id, $recruiter_name,
            $full_name, $nationality, $register_mobile, $register_home,
            $address_1, $address_2, $address_city, $address_state, $postal_code, $address_country_code,
            $bank_name, $bank_account_name, $bank_account_number,
            $advisor_language, $advisor_specialities, $alias, $send_update_email,
            $email_marketing_channel, $sms_marketing_channel, $tel_marketing_channel
        )
        setTimeout(() => {
            $loader.hide();
            if (is_tm4u) {
                var product_link = $(evt).attr('data-product-link');
                if (product_link) { 
                    window.location.href = product_link;
                }
            } else {
                location.reload();
            }
        }, 15000);
    } else {
        $loader.hide();
    }
}
updatePdpa = (evt) =>{
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    var $shopifyId = parseInt($('#jsc-customer-id').val());

    var $address_1 = $('#address_1').val();
    var $address_2 = $('#address_2').val();
    var $address_city = $('#address_city').val();
    var $address_state = $('#address_state').val();
    var $postal_code = $('#postal_code').val();
    var $address_country_code = $('#address_country_code').val();

    var $accepts_policy = $('#accepts_policy').prop("checked");

    var $isvalidatedAddress = addressValidation($address_1, $address_city, $address_state, $postal_code);
    var $isvalidatedAcceptsCondition = true;
    if (!$accepts_policy) {
        $('#accepts_policy_error').show();
        $isvalidatedAcceptsCondition = false;
    } else {
        $('#accepts_policy_error').hide();
    }

    console.log('isvalidatedAddress: ', $isvalidatedAddress);

    if ($isvalidatedAddress && $isvalidatedAcceptsCondition) {
        customerAPI($shopifyId,
            $address_1, $address_2, $address_city, $address_state, $postal_code, $address_country_code
        )
        setTimeout(() => {
            $loader.hide();
            location.reload();
        }, 4500);
    } else {
        $loader.hide();
    }
}
openOptions = (e) => {
    const _this = $(e);
    const optionsEl = _this.siblings('.custom-options');
    _this.toggleClass('active');
    optionsEl.toggleClass('d-none');
}
// track specialities
updateSpecialities = (e) => {
    const _this = $(e);
    const specialitiesLabel = $('#specialities_label').text();
    var specialitiesArr = specialitiesLabel.split(',');
    var addSpecialities = false;

    if (_this.prop("checked")){
        addSpecialities = true;
    }

    if (addSpecialities && specialitiesLabel != 'Specialities') {
        specialitiesArr.push(_this.val());
    } else if (addSpecialities && specialitiesLabel == 'Specialities') {
        specialitiesArr.push(_this.val());
        specialitiesArr = specialitiesArr.filter(function(item) {
            return item !== 'Specialities';
        });
    }

    if (addSpecialities === false) {
        specialitiesArr = specialitiesArr.filter(function(item) {
            return item !== _this.val();
        });
    }

    if (specialitiesArr.length <= 0) {
        $('#specialities_blank_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    }else if (specialitiesArr.length > 3) {
        $('#specialities_blank_error').hide();
        $('#specialities_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    } else {
        $('#specialities_blank_error').hide();
        $('#specialities_error').hide();
        $('#specialities_label').text(specialitiesArr.join(','));
        if ($('#update-profile').prop("disabled")) {
            $('#update-profile').prop("disabled", false);
        }
    }
};
// track language
updateLanguage = (e) => {
    const _this = $(e);
    const langLable = $('#language_label').text();
    var langArr = langLable.split(',');
    var addLang = false;

    if (_this.prop("checked")){
        addLang = true;
    }

    if (addLang && langLable != 'Language') {
        langArr.push(_this.val());
    } else if (addLang && langLable == 'Language') {
        langArr.push(_this.val());
        langArr = langArr.filter(function(item) {
            return item !== 'Language';
        });
    }

    if (addLang === false) {
        langArr = langArr.filter(function(item) {
            return item !== _this.val();
        });
    }

    if (langArr.length <= 0) {
        $('#language_blank_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    }else if (langArr.length > 5) {
        $('#language_blank_error').hide();
        $('#language_error').show();
        _this.closest('.custom-options').toggleClass('d-none');
        _this.prop("checked", !_this.prop("checked"));
    } else {
        $('#language_blank_error').hide();
        $('#language_error').hide();
        $('#language_label').text(langArr.join(','));
        if ($('#update-profile').prop("disabled")) {
            $('#update-profile').prop("disabled", false);
        }
    }
};
// end: pdpa function
// start: Recover Password Form
showRecoverPasswordForm = () => {
    const recoverPasswordForm = $('#RecoverPasswordForm').attr('aria-hidden');
    console.log('recoverPasswordForm: ', recoverPasswordForm);
    if (recoverPasswordForm === "true") {
        $('#RecoverPasswordForm').attr('aria-hidden', 'false');
        $('#RecoverPasswordForm').removeClass('hide');
        $('#CustomerLoginForm').addClass('hide');
        $('#CustomerLoginForm').attr('aria-hidden', 'true');
    }
}
hideRecoverPasswordForm = () => {
    const recoverPasswordForm = $('#RecoverPasswordForm').attr('aria-hidden');
    console.log('recoverPasswordForm: ', recoverPasswordForm);
    if (recoverPasswordForm === "false") {
        $('#RecoverPasswordForm').attr('aria-hidden', 'true');
        $('#RecoverPasswordForm').addClass('hide');
        $('#CustomerLoginForm').removeClass('hide');
        $('#CustomerLoginForm').attr('aria-hidden', 'false');
    }
}
// end: Recover Password Form
// start: section anchor
getAnchorLink = (evt) => {
    var anchorLink = $(evt).attr('href');
    scrollToSection(anchorLink);
}
onloadGetAnchorLink = () => {
    var anchorLink = window.location.hash;
    console.log('onloadGetAnchorLink: ', onloadGetAnchorLink);
    if(anchorLink != "") {
      scrollToSection(anchorLink);
    }
}
scrollToSection = (link) => {
    var target = $('[data-anchor="' + link + '"]:first');
    if(target.length > 0) {
      window.location.hash = link;
      var top = target.offset().top - 150;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
}
// end: section anchor
// start: referral link
copyReferralLink = () => {
    // Get the text field
    var referralLink = $('#referral_link')[0];

    // Select the text field
    referralLink.select();
    referralLink.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the text field
    navigator.clipboard.writeText(referralLink.value).then(function() {
        $('#copied-label').fadeIn().delay(1000).fadeOut();
    }).catch(function(error) {
        console.error("Failed to copy text: " + error);
    });;
};
// end: referral link
checkReferral = async () => {
    const $loader = $('.jsc-loader-overlay');
    console.log('Checking referral...');
    $loader.show();

    try {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('ref')) {
            console.log('No referral parameter found');
            return;
        }

        // Parse referral data
        const ref = urlParams.get('ref');
        const [refId, refNameEncoded] = ref.split('@');
        const refName = refNameEncoded?.replace(/_/g, ' ') || '';
        console.log('Referral ID:', refId, 'Name:', refName);

        // Get current advisor data
        const currentAdvisorId = localStorage.getItem('Advisor ID');
        const storedRefId = localStorage.getItem('Referral ID');

        // Check if this is a new referral or different from current advisor
        // const isNewReferral = refId !== storedRefId;
        // const isDifferentAdvisor = refId !== currentAdvisorId;

        // if (!isNewReferral && !isDifferentAdvisor) {
        //     console.log('Referral already set as advisor');
        //     return;
        // }

        // Validate if referral is a valid advisor and get profile picture
        const advisorValidation = await validateAdvisor(refId);

        if (advisorValidation) {
            // advisorValidation is [true, profilePicture]
            const [isValid, profilePicture] = advisorValidation;
            
            if (isValid) {
                // Update localStorage with new advisor data including profile picture
                updateAdvisorData(refId, refName, profilePicture, true);
                console.log('Advisor updated successfully with profile picture:', profilePicture);
            } else {
                // Validation returned false, clear advisor data
                clearAdvisorData();
                console.log('Referral validation failed, advisor data cleared');
            }
        } else {
            // Validation returned false, clear advisor data
            clearAdvisorData();
            console.log('Referral is not a valid advisor, advisor data cleared');
            location.href = `/pages/choose-from-your-nearest-advisors`;
        }
    } catch (error) {
        console.error('Error in checkReferral:', error);
    } finally {
        $loader.hide();
    }
}

// Helper function to validate if an ID belongs to a valid advisor and fetch profile picture
const validateAdvisor = async (advisorId) => {
    try {
        const response = await fetch(`/pages/storepoint-my/id_${advisorId}`);
        console.log('validate advisor for referral: ', response.status)
        if (response.status === 404) {
            return false;
        }

        const html = await response.text();

        // Create a temporary div to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const advisorIdInput = tempDiv.querySelector('input[name="advisor_id"]');
        console.log('advisorIdInput: ', advisorIdInput, 'advisorId (param): ', advisorId );

        if (!advisorIdInput) {
            return false;
        }

        const advisorIdParam = `id_${advisorId}`.toLowerCase();
        const advisorInputStr = advisorIdInput.value.trim().toLowerCase();

        if (advisorInputStr === advisorIdParam) {
            // Find the hidden input with profile picture
            const profilePictureInput = tempDiv.querySelector('input[name="advisor_profile_picture"]');
            let profilePicture = '';
            if (profilePictureInput && profilePictureInput.value) {
                profilePicture = profilePictureInput.value;
            }
            return [true, profilePicture]
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error validating advisor:', error);
        return false;
    }
}

// Helper function to update advisor data in localStorage, cart attributes and UI
const updateAdvisorData = (advisorId, advisorName, advisorProfilePicture = '', isReferral = false) => {
    // Update localStorage
    localStorage.setItem('Advisor ID', advisorId);
    localStorage.setItem('Advisor Name', advisorName);
    localStorage.setItem('Advisor Profile Picture', advisorProfilePicture);
    var storepointID = window.location.href.split('selected=')[1];
    // console.log('storepointID 2',storepointID);
    localStorage.setItem('Advisor Storepoint ID', storepointID);

    // Only update referral localStorage if isReferral is true
    if (isReferral) {
        localStorage.setItem('Referral ID', advisorId);
        localStorage.setItem('Referral Name', advisorName);
    }

    // Update cart attributes
    CartJS.setAttributes({
        'Advisor ID': advisorId,
        'Advisor Name': advisorName,
        'Advisor Profile Picture': advisorProfilePicture
    });

    // Update UI if element exists
    const $advisorNameElement = $('#jsc-cart-advisor-name');
    if ($advisorNameElement.length) {
        $advisorNameElement.text(advisorName);
    }

    // Dispatch advisor:selected event for any listeners
    document.dispatchEvent(new CustomEvent('advisor:selected', {
        detail: {
            id: advisorId,
            name: advisorName,
            profileImg: advisorProfilePicture
        }
    }));
}

// Helper function to clear advisor data from localStorage, cart attributes and UI
const clearAdvisorData = () => {
    // Clear localStorage
    localStorage.removeItem('Advisor ID');
    localStorage.removeItem('Advisor Name');
    localStorage.removeItem('Advisor Profile Picture');
    localStorage.removeItem('Referral ID');
    localStorage.removeItem('Referral Name');
    localStorage.removeItem('Advisor Storepoint ID');

    // Clear cart attributes
    CartJS.setAttributes({
        'Advisor ID': '',
        'Advisor Name': '',
        'Advisor Profile Picture': '-'
    });

    // Clear UI if element exists
    const $advisorNameElement = $('#jsc-cart-advisor-name');
    if ($advisorNameElement.length) {
        $advisorNameElement.text('');
    }

    // Clear advisor name input if exists
    const $advisorNameInput = $('#jsc-cart-advisor-name-input');
    if ($advisorNameInput.length) {
        $advisorNameInput.val('');
    }

    // Clear search advisor input if exists
    const $searchAdvisorInput = $('#search-advisor');
    if ($searchAdvisorInput.length) {
        $searchAdvisorInput.val('');
    }

    // Dispatch advisor:cleared event for any listeners
    document.dispatchEvent(new CustomEvent('advisor:cleared'));
}

hideCustomerCartInput = () => {
    const refId = localStorage.getItem('Referral ID');
    const refName = localStorage.getItem('Referral Name');
    if (refId && refName) {
        if (!$('.jsc-customer-input').hasClass('d-none')) {
            $('.jsc-customer-input').addClass('d-none');
        }
        localStorage.setItem('Previous Demo Experience?', '-');
        localStorage.setItem('Would you like to select a preferred advisor?', '-');
    } else {
        if ($('.jsc-customer-input').hasClass('d-none')) {
            $('.jsc-customer-input').removeClass('d-none');
        }
    }
}
// start: tm4u
onloadTm4u = () => {
    assignTm4uLocalStorage();
    redirectTm4uStep2Page();
    resetDuplicatedTag();
} 
getQueryParam = (param) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}
assignTm4uLocalStorage = () => {
    const tm4uValue = getQueryParam("tm4u");
    if (tm4uValue === "true") {
        localStorage.setItem("tm4u", tm4uValue);
    }

    const comingFrom = getQueryParam("from");
    if (comingFrom === "newcomer-step-2" || comingFrom == "newcomer-owned") {
        localStorage.setItem("tm4u-redirect-link", comingFrom);
    }
}
redirectTm4uStep2Page = () =>{ 
    setTimeout(() => {
        if (window.location.pathname == '/pages/advisor-page' || window.location.pathname == '/account' || window.location.pathname == '/') {
            if (localStorage.getItem("tm4u") === "true" && localStorage.getItem("tm4u-redirect-link") != "") {
                localStorage.removeItem("tm4u");
                window.location.href = `/pages/${localStorage.getItem("tm4u-redirect-link")}`;
            }
        }
    }, 900);
}

showConfirmation = () =>{
    let nric = $('#tm4u_nric_verify').val();

    if (nric.length == 12) {
        $('#confirm-nric').text(nric);
        $('#jsc-tm4u-overlay').css('display', 'block');
        $('#jsc-tm4u-popup').show();
    } else {
        $('#nric-digit-error').show();
    }
}
closeConfirmation = () =>{
    $('#jsc-tm4u-overlay').css('display', 'none');
    $('#jsc-tm4u-popup').hide();
}
verifyNRIC = (e,id) =>{
    const $loader = $('.jsc-loader-overlay');
    let mechanic_webhook = 'https://webhooks.mechanic.dev/72cb947a-eca1-4c04-9477-144127244ef5';
    let nric = $('#tm4u_nric_verify').val();
    let this_customer_id = `gid://shopify/Customer/${id}`;
    let $data = {
        nric: nric,
        gid: this_customer_id
    };
    
    $.ajax({
        url: mechanic_webhook, //user/verify/nric
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        data: JSON.stringify($data),
        success: function(response) {
            console.log("Success:", response);
            // $loader.append(`<p class="verify-load">Hang tight! We're verifying your details—this might take a moment. No need to refresh, we've got this! 🚀</p>`);
            $loader.show();
            setTimeout(() => {
                location.reload();
            }, 10000);
        },
        error: function(xhr, status, error) {
            console.error("Error:", xhr.responseText);
            // alert("An error occurred: " + xhr.responseText);
        }
    });
}
limitInput = (input, maxLength) => {
    if (input.value.length > maxLength) {
        input.value = input.value.slice(0, maxLength);
    }
}
resetDuplicatedTag = () =>{
    let reset_duplicate_tag = $('#reset_duplicated_tag');
    if (reset_duplicate_tag.length) {
        let id = reset_duplicate_tag.val();
        let mechanic_webhook = 'https://webhooks.mechanic.dev/12744d05-1a49-4747-993a-aeba4a3e601f';
        let this_customer_id = `gid://shopify/Customer/${id}`;
        let $data = {
            gid: this_customer_id,
        };
        
        $.ajax({
            url: mechanic_webhook, //user/verify/reset
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            data: JSON.stringify($data)
        });
    }
}
submitstep2b = (e) =>{
    // click upload NRIC
    $('.cf-submit-form').click();
    
    setTimeout(() => {
        if ($('.cf-step-invalid').length) {
            $('html, body').animate({
                scrollTop: $('.cf-step-invalid').first().offset().top - 120
            }, 500);            
        } else {
            if ($('.jsc-accepts_policy').length === $('.jsc-accepts_policy:checked').length) {
                $('#accepts_policy_error').hide();
                updatePdpaAdvisor(e,true);
                $('html, body').animate({
                    scrollTop: $('.step2b').first().offset().top - 120
                }, 500);
            } else {
                $('#accepts_policy_error').show();
            }
        }
    }, 1200);
}
// end: tm4u
// start: register form
submitRegisterForm = (e) =>{
    console.log('submitRegisterForm...')
    const password = $('#CreatePassword').val();
    const phone = $('#jsc-telephone').val();
    const address1 = $('#jsc-address1').val();
    const address2 = $('#jsc-address2').val();
    const state = $('#jsc-state').attr('data-default');
    const city = $('#jsc-city').val();
    const postalCode = $('#jsc-postal-code').val();
    const $loader = $('.jsc-loader-overlay');
    var passRegister = true;

    $loader.show();
    console.log('jsc-telephone: ', phone);
    // Check if password length is less than 12
    if (password.length < 12) {
        $('#password-error').show(); // Show error message
        passRegister = false;
    } else {
        $('#password-error').hide(); // Hide error message
    }

    // Check if the phone follow Sinagpore mobile fomat
    if (phone != '' || phone != '+60') {
        $('#phone-blank-error').hide();
        if (phone.match(/^\+60(1[0-9]{8,9})$/)) {
            $('#phone-format-error').hide(); // Show error message
        } else {
            $('#phone-format-error').show(); // Hide error message
            passRegister = false;
        }
    } else {
        $('#phone-blank-error').show();
        passRegister = false;
    }

    // Check address 1
    if (address1 == '') {
        $('#address1-blank-error').show();
        passRegister = false;
    } else {
        $('#address1-blank-error').hide();
    }

    // Check city
    if (city == '') {
        $('#city-blank-error').show();
        passRegister = false;
    } else {
        $('#city-blank-error').hide();
    }

    // Check state
    if (state == '') {
        $('#state-blank-error').show();
        passRegister = false;
    } else {
        $('#state-blank-error').hide();
    }

    // Check postal code format
    if (postalCode == ''){
        $('#zip-blank-error').show();
        passRegister = false;
    } else {
        $('#zip-blank-error').hide();
        if (postalCode.match(/^\d{5}$/)) {
            $('#zip-format-error').hide();
        } else {
            $('#zip-format-error').show();
            passRegister = false;
        }
    }

    console.log('passRegister: ', passRegister);
    if(passRegister) {
        $('#register-form-error').hide();
        const formated_address1 = address1.replace(/,/g, '%&%');
        const formated_address2 = address2.replace(/,/g, '%&%');
        const formated_city = city.replace(/,/g, '%&%');
        const customer_tag = `__tel:${phone},__address1:${formated_address1},__address2:${formated_address2},__city:${formated_city},__province:${state},__zip:${postalCode}`;
        $('#jsc-customer-tag').val(customer_tag);
        // console.log('customer_tag: ', customer_tag);
        setTimeout(() => {
            $('#register-submit').click();
        }, 5000);
    } else {
        $('#register-form-error').show();
        $loader.hide();
    }
}
// end: register form
// start: map loading modal
showMapLoading = () => {
    console.log('showMapLoading...');
    $('#map-loading-modal').fadeIn();
    $('body').addClass('disabled-event');

    // Set a timeout to hide the modal after 5 seconds (5000 ms)
    setTimeout(function() {
        $('#map-loading-modal').fadeOut();
        $('body').removeClass('disabled-event');
    }, 5000);
}
//end: map loading modal
// start: onload loader
onLoadLoader = () => {
    var $loader = $('.jsc-loader-overlay');
    $loader.show();
    $(window).on('load', function() {
        setTimeout(function() {
            $loader.hide();
        }, 2000);
    });
}
// end: onload loader

//start:Pagination
tablePaginate = () =>{
    console.log('ssss', $('#jsc-advisor-report'));
    
    if($('#jsc-advisor-report').length > 0) {
        console.log('He');
        
        // let table = new DataTable('#jsc-advisor-report', {
        //     responsive: true,
        //     paging: false,
        //     pageLength: 20
        // });
    }
}
//end:Pagination

// Function to save order table rows to localStorage
saveOrderTableRows = () => {
    const orderTableRows = $('.row-advisor-data tr').map(function() {
        return $(this).prop('outerHTML');
    }).get();
    
    localStorage.setItem('orderTableRows', JSON.stringify(orderTableRows));
    console.log('Order table rows saved to localStorage');
}
let filteredOrderTable;
getFilteredOrder = (searchText = '') => {
    const params = new URLSearchParams(window.location.search);
    const startDateParam = params.get('startDate');
    const endDateParam = params.get('endDate');
    const $loader = $('.jsc-loader-overlay');
    let filterByDate = false;

    $loader.show();

    searchText = searchText || $('#jsc-advisor-search').val() || ""
    console.log('searchText: ', searchText)

    if (!startDateParam || !endDateParam) {
        localStorage.removeItem('orderStartDate');
        localStorage.removeItem('orderEndDate');
    } else {
        filterByDate = true
    }

    console.log('startDateParam: ', startDateParam);
    console.log('endDateParam: ', endDateParam);

    const storedRows = localStorage.getItem('orderTableRows');
    if (!storedRows) {
        $loader.hide();
        return;
    }

    try {
        const orderTableRows = JSON.parse(storedRows);
        let startDate = new Date();
        let endDate = new Date();
        console.log('orderTableRows count:', orderTableRows.length);

        if (filterByDate) {
            // Parse dates once
            startDate = new Date(startDateParam);
            endDate = new Date(endDateParam);
            endDate.setHours(23, 59, 59, 999); // Set end date to end of day
        }

        // Filter rows based on date range
        const filteredRows = orderTableRows.filter(row => {
            // Extract date from the row
            let rowMatchCondition = false;
            if (searchText !== '') {
                rowMatchCondition = row.match(/data-label="([^"]+)">([^<]+)<\/td>/g)
                .some(cell => {
                    const cellMatch = cell.match(/data-label="([^"]+)">([^<]+)<\/td>/);
                    return cellMatch && cellMatch[2].toLowerCase().includes(searchText.toLowerCase());
                });
            }

            let dateMatchCondition = false;
            if (filterByDate) {
                const dateMatch = row.match(/data-label="Date">([^<]+)<\/td>/);

                // Check if the row contains the date and if it is within the desired range
                if (dateMatch && dateMatch[1]) {
                    const rowDate = new Date(dateMatch[1].split('/').reverse().join('-'));
                    dateMatchCondition = rowDate >= startDate && rowDate <= endDate;
                }
            }

            if (!filterByDate && searchText === "") {
                rowMatchCondition = true
            }
            // Return true if either the date matches or the row match condition is true
            return dateMatchCondition || rowMatchCondition;
        });

        console.log('filteredRows count:', filteredRows.length);

        // Create table HTML structure
        const tableHeader = '<table id="jsc-advisor-report-filter-range" class="table--responsive table--small-text">' +
            '<thead><tr>' +
            '<th>Order Number</th>' +
            '<th>Date</th>' +
            '<th>Return Order ID</th>' +
            '<th>Advisor ID</th>' +
            '<th>Advisor Name</th>' +
            '<th>Team Leader ID</th>' +
            '<th>Team Leader</th>' +
            '<th>Branch Manager ID</th>' +
            '<th>Branch Manager</th>' +
            '<th>Product Description</th>' +
            '<th>Order Quantity</th>' +
            '</tr></thead><tbody>';

        const tableFooter = '</tbody></table>';

        // '<th>Customer Name</th>' +
        // '<th>Customer Email</th>' +
        // '<th>Customer Phone Number</th>' +

        // Join filtered rows and create complete table HTML
        const tableRowHtml = filteredRows.length > 0
            ? tableHeader + filteredRows.join('') + tableFooter
            : tableHeader + '<td colspan="11" class="dt-empty">No matching records found</td>' + tableFooter

        // Update UI
        if (filteredOrderTable) {
            filteredOrderTable.destroy();
        }

        // Update the filtered table content
        $('.row-advisor-data-filter').empty().append(tableRowHtml);
        $('.row-advisor-data-filter').removeClass('hide');

        // Initialize DataTable if there are rows
        if (filteredRows.length > 0) {
            $('#jsc-advisor-report-filter-range').DataTable({
                pageLength: 20,
                order: [
                    [0, 'desc']
                ],
                lengthChange: false,
                columnDefs: [
                    { targets: '_all', width: 'auto' }
                ],
                scrollX: true,
                searching: false
            });
        }

        // Update UI elements
        $('#jsc-advisor-report-filter').css('display', 'block');
        $('#table-account').css('display', 'none');
        $('.unfilterpagination').css('display', 'none');
        if (filterByDate) {
            $('#calendar-container').find('.date-range-clear-button').removeClass('d-none-important');
            $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label').text(`${startDateParam} - ${endDateParam}`);
            $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label-img').addClass('d-none-important');
            $('#calendar-container').siblings('#toggle-calendar').attr('data-open', false);
        }
        $('#jsc-advisor-report_wrapper').hide();
    } catch (error) {
        console.error('Error processing filtered orders:', error);
    } finally {
        $loader.hide();
    }
}
formatDate = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
}
$('.date-range-apply-button').on('click', (e) => {
    var _this = $(e.currentTarget);
    var startDateText = _this.parent().siblings().find('#acc-order-start-date-text').text();
    var endDateText = _this.parent().siblings().find('#acc-order-end-date-text').text();
    var $loader = $('.jsc-loader-overlay');
    var tableRowHtml = ''

    $loader.show();
    if (startDateText != 'yyyy-mm-dd' && endDateText != 'yyyy-mm-dd') {
        const startDate = new Date(startDateText);
        const endDate = new Date(endDateText);
        if (startDate <= endDate) {
            let currentUrl = new URL(window.location.href);
            let params = currentUrl.searchParams;
            let pageNumber = params.get('page');

            if (pageNumber) {
                params.delete('page');
            }

            params.set('startDate', startDateText);
            params.set('endDate', endDateText);

            window.history.replaceState({}, '', `${currentUrl.pathname}?${params.toString()}`);
            getFilteredOrder();
        } else {
            alert('Please ensure that the start date of the filter is earlier than the end date.')
        }
    }
    $loader.hide();
});
$('#jsc-advisor-search').on('keyup', function() {
    let inputValue = $(this).val();
    getFilteredOrder(inputValue);
});
$('#toggle-calendar').on('click', (e) => {
    console.log('qwqeqwe');
    
    var _this = $(e.currentTarget);
    let params = new URLSearchParams(window.location.search);
    let startDateParam = params.get('startDate');
    let endDateParam = params.get('endDate');

    if(startDateParam) {
        $('#acc-order-start-date-text').text(startDateParam);
    } else {
        $('#acc-order-start-date-text').text('yyyy-mm-dd');
    }
    if(endDateParam) {
        $('#acc-order-end-date-text').text(endDateParam);
    } else {
        $('#acc-order-end-date-text').text('yyyy-mm-dd');
    }

    var open = _this.attr('data-open') === 'true';
    _this.attr('data-open', !open);
});
initInlineDatePicker = () => {
    console.log('initInlineDatePicker');
    const today = new Date();
    const maxDate = $.datepicker.formatDate('mm/dd/yy', today);

    $("#acc-order-start-date").datepicker({
        inline: true,
        maxDate: maxDate,
        onSelect: function(dateText) {
            const selectedDate = $(this).datepicker("getDate");
            const formattedSelectedDate = formatDate(selectedDate);

            $('#acc-order-start-date-text').text(formattedSelectedDate);
            localStorage.setItem('orderStartDate', $.datepicker.formatDate('mm/dd/yy', selectedDate));
        }
    });
    $("#acc-order-end-date").datepicker({
        inline: true,
        maxDate: maxDate,
        onSelect: function(dateText) {
            const selectedDate = $(this).datepicker("getDate");
            const formattedSelectedDate = formatDate(selectedDate);

            $('#acc-order-end-date-text').text(formattedSelectedDate);
            localStorage.setItem('orderEndDate', $.datepicker.formatDate('mm/dd/yy', selectedDate));
        }
    });

    const startDate = localStorage.getItem('orderStartDate');
    const endDate = localStorage.getItem('orderEndDate');
    if (startDate) {
        $("#acc-order-start-date").datepicker("setDate", startDate);
        var [month, day, year] = startDate.split('/')
        $('#acc-order-start-date-text').text(`${year}-${month}-${day}`);
    }
    if (endDate) {
        $("#acc-order-end-date").datepicker("setDate", endDate);
        var [month, day, year] = endDate.split('/')
        $('#acc-order-end-date-text').text(`${year}-${month}-${day}`);
    }
}
$('.date-range-clear-button').on('click', (e) => {
    localStorage.removeItem('orderStartDate');
    localStorage.removeItem('orderEndDate');
    
    // Clear URL parameters without refreshing the page
    let currentUrl = new URL(window.location.href);
    let params = currentUrl.searchParams;
    
    // Remove startDate and endDate parameters
    params.delete('startDate');
    params.delete('endDate');
    
    // Update the URL without refreshing the page
    window.history.replaceState({}, '', `${currentUrl.pathname}${params.toString() ? '?' + params.toString() : ''}`);
    
    // Reset the date picker text fields
    $('#acc-order-start-date-text').text('yyyy-mm-dd');
    $('#acc-order-end-date-text').text('yyyy-mm-dd');
    
    // Hide the clear button
    $('#calendar-container').find('.date-range-clear-button').addClass('d-none-important');
    
    // Reset the toggle calendar label
    $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label').text('Select Date Range');
    $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label-img').removeClass('d-none-important');

    $('.row-advisor-data-filter').empty();
    $('.row-advisor-data-filter').addClass('hide');
    $('#jsc-advisor-report_wrapper').show();
    getFilteredOrder();
});
// start: faq collapsible
showMoreCollapsible = (e) => {
    const _this = $(e);
    const _container = $(e).parent();
    const _showLessBtn = _this.siblings('.collapsible-show-less');
    const _siblings = _this.siblings('.jsc-faq-collapsible.d-none');
    console.log('_siblings: ', _siblings)
    if (_siblings.length > 0){
        $.each(_siblings, function(index, element) {
            $(element).removeClass('d-none');
        });
        _this.css('display', 'none');
        _showLessBtn.css('display', 'block');
        _showLessBtn.insertAfter(_container.find('.jsc-faq-collapsible').last());
    }
}
showLessCollapsible = (e) => {
    const _this = $(e);
    const _showMoreBtn = _this.siblings('.collapsible-show-more');
    const _siblings = _this.siblings('.jsc-faq-collapsible');
    $.each(_siblings, function(index, element) {
        $(element).addClass('d-none');
    });
    _this.css('display', 'none');
    _showMoreBtn.css('display', 'block');
}
// end: faq collapsible
initAdvisorSelector = () => {
    // Ensure advisor selector is properly initialized on page load
    const advisorID = localStorage.getItem('Advisor ID');
    const advisorName = localStorage.getItem('Advisor Name');
    const demoValue = localStorage.getItem('Previous Demo Experience?');
    
    console.log('initAdvisorSelector - advisorID:', advisorID);
    console.log('initAdvisorSelector - advisorName:', advisorName);
    console.log('initAdvisorSelector - demoValue:', demoValue);
    
    // If we have an advisor selected and demo experience is "Yes", show the advisor selector
    if (advisorID && advisorID !== '-' && demoValue === 'Yes') {
        if ($('.jsc-advisor-select').length && $('.jsc-advisor-select').hasClass('d-none')) {
            console.log('Showing advisor selector on page load');
            $('.jsc-advisor-select').removeClass('d-none');
        }
    }
}
// start: download pdf (print)
triggerDownloadPdf = (e, contentId) => {
    const _this = $(e);
    let $content = $('#' + contentId);
    let divContents = $content.length ? $content.html() : '';

    if (divContents !== '') {
        let styleSheet1 = _this?.attr('data-css1') || '';
        let styleSheet2 = _this?.attr('data-css2') || '';
        let printWindow = window.open('', '', 'height=800,width=800');

        let htmlContent = '<html><head><title>Print E-Business Card</title>';
        if (styleSheet1 !== '') {
            htmlContent += `<link rel="stylesheet" href="${styleSheet1}" preload>`;
        }
        if (styleSheet2 !== '') {
            htmlContent += `<link rel="stylesheet" href="${styleSheet2}" preload>`;
        }
        htmlContent += `</head><body><div class="page-width page-content">${divContents}</div></body></html>`;

        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();

        setTimeout(function () {
            printWindow.print();
        }, 1000);
    }
}
// end: download pdf (print)
// start: remove customer update error tag
removeProfileUpdateError = () =>{
    var isTriggerRemoveTag = $('#trigger-remove-error').length;
  
    if (isTriggerRemoveTag) {
      var tag_val = $('#trigger-remove-error').val();
      var customer_id = $('#trigger-remove-error').attr('data-id');
    //   alert('tag_val: ' + tag_val + ' id: ' + customer_id)
      let _data = {
        tagsToRemove: tag_val,
        id: customer_id
      };
      $.ajax({
        url: 'https://webhooks.mechanic.dev/6fbf5142-f00a-4b48-8e5b-454f6c6f1883', // user/custom/remove_tags
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        data: JSON.stringify(_data)
      }).done(function () {
        
      });
    }
}
// end: remove customer update error tag

// start: implement overlay when menu dropdown is open
function toggleMegaMenuOverlay() {
    const detailsList = document.querySelectorAll('.site-nav__details');
    const headerElements = document.querySelectorAll('.site-header__element');
    const mainContent = document.querySelector('.main-content');

    if (detailsList.length === 0 || headerElements.length === 0 || !mainContent) return;

    // Check if ANY dropdown is open
    const isAnyOpen = Array.from(detailsList).some(details => details.hasAttribute('open'));

    if (isAnyOpen) {
      // Full-page blur overlay inside .main-content
      if (!document.querySelector('.jsc-blurred-overlay')) {
        const overlay = document.createElement('div');
        overlay.classList.add('jsc-blurred-overlay');
        mainContent.appendChild(overlay);
      }

      // Light overlays only for first 2 header elements
      headerElements.forEach((headerElement, index) => {
        if (index < 2 && !headerElement.querySelector('.jsc-light-overlay')) {
          const lightOverlay = document.createElement('div');
          lightOverlay.classList.add('jsc-light-overlay');
        //   headerElement.style.position = 'relative';
          headerElement.appendChild(lightOverlay);
        }
      });
  
      document.addEventListener('click', handleOutsideClick);
    } else {
      removeMegaMenuOverlay();
    }
}
  
function removeMegaMenuOverlay() {
    document.querySelector('.jsc-blurred-overlay')?.remove();
    document.querySelectorAll('.jsc-light-overlay').forEach(el => el.remove());

    // Close ALL open details
    document.querySelectorAll('.site-nav__details[open]').forEach(details => {
        details.removeAttribute('open');
    });

    document.removeEventListener('click', handleOutsideClick);
}
  
function handleOutsideClick(event) {
    const detailsList = document.querySelectorAll('.site-nav__details');
    if ([...detailsList].every(details => !details.contains(event.target))) {
    removeMegaMenuOverlay();
    }
}

// --- New close button logic ---
const closeIcons = document.querySelectorAll('.jsc-close-icon');
if (closeIcons.length > 0) {
  closeIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      e.preventDefault();
      removeMegaMenuOverlay();
    });
  });
}

// Observe ALL details elements
const targets = document.querySelectorAll('.site-nav__details');
targets.forEach(target => {
    const observer = new MutationObserver(toggleMegaMenuOverlay);
    observer.observe(target, { attributes: true, attributeFilter: ['open'] });
});
// end: implement overlay when menu dropdown is open

//start: disable background scrolling when mobile menu is open
toggleBodyScroll = () => {
    $(document).on('click', '.mobile-nav-trigger', function () {
        if ($('.jsc-mobile-nav-bg-color').hasClass('is-active')) {
          $('body').addClass('no-scroll');
        } else {
          $('body').removeClass('no-scroll');
        }
    });
}
//end: disable background scrolling when mobile menu is open

//start: tax invoice
fullTaxInvoice = async (e) => {
  const $this = $(e);
  const $val = $this.val();
  // Clear any existing error messages when user makes a selection
  $('.jsc-tax-invoice-error-message').remove();

  const $companyHtml = `
    <div class="jsc-full-tax-company__container">
        <label for="jsc-full-tax-company-name">Company Name <span class="tax-required"></span></label>
        <input id="jsc-full-tax-company-name" type="text" name="attributes[Company Name]" value="">
        <label for="jsc-full-tax-company-registration-no">Company Registration No <span class="tax-required"></span></label>
        <input id="jsc-full-tax-company-registration-no" type="number" name="attributes[Company Registration No]" value="">
        <p id="jsc-invoice-warning" style="color: red;">* In accordance with the regulations on the use of unified invoices, once an invoice is issued, it cannot be changed or reissued with another unified numbered invoice.</p>
        <div class="jsc-form-group">
            <input type="checkbox" id="full-tax-invoice-policy" name=attribute[Tax Policy]" value="agreed" required class="jsc-form-group-input">
            <label for="full-tax-invoice-policy" class="jsc-form-group-input">I agree that when I return goods, Vorwerk will handle the invoice and sales return certificate on my behalf to expedite the return and refund process. <span class="tax-required"></span></label>
        </div>
        <div class="jsc-tax-invoice-save-btn" onclick="saveCartAttr(this)">Save to update</div>
    </div>
  `;

  const $personalHtml = `
    <div class="jsc-full-tax-personal__container">
        <p id="jsc-invoice-warning" style="color: red; font-size: 12px; margin-top: 2px; display: block; width: 100%;">* According to the regulations on the use of unified invoices, once an invoice is issued, it cannot be changed or reissued as an invoice with a different unified number.</p>
        <div class="jsc-form-group">
            <input type="checkbox" id="full-tax-invoice-policy" name=attribute[Tax Policy]" value="agreed" required class="jsc-form-group-input">
            <label for="full-tax-invoice-policy" class="jsc-form-group-input">I agree that when I return goods, Vorwerk will handle the invoice and sales return certificate on my behalf to expedite the return and refund process. <span class="tax-required"></span></label>
        </div>
        <div class="jsc-tax-invoice-save-btn" onclick="saveCartAttr(this)">Save to update</div>
    </div>
  `;

  const $mobileCarrierHtml = `
    <div class="jsc-full-tax-mobile-carrier__container">
        <label for="jsc-mobile-carrier-no-mandatory">Mobile Carrier No (/+7 digits (chars)) eg: /MA.234V<span class="tax-required"></span></label>
        <input id="jsc-mobile-carrier-no-mandatory" type="text" name="attributes[Mobile Carrier No]" value="" placeholder="/+7 digits (chars)">
        <p id="jsc-invoice-warning" style="color: red; font-size: 12px; margin-top: 2px; display: block; width: 100%;">* According to the regulations on the use of unified invoices, once an invoice is issued, it cannot be changed or reissued as an invoice with a different unified number.</p>
        <div class="jsc-form-group">
            <input type="checkbox" id="full-tax-invoice-policy" name=attribute[Tax Policy]" value="agreed" required class="jsc-form-group-input">
            <label for="full-tax-invoice-policy" class="jsc-form-group-input">I agree that when I return goods, Vorwerk will handle the invoice and sales return certificate on my behalf to expedite the return and refund process. <span class="tax-required"></span></label>
        </div>
        <div class="jsc-tax-invoice-save-btn" onclick="saveCartAttr(this)">Save to update</div>
    </div>
  `;

  // Clean UI first
  $('.jsc-full-tax-company__container').remove();
  $('.jsc-full-tax-personal__container').remove();
  $('.jsc-full-tax-mobile-carrier__container').remove();

  if ($val === 'Company') {
    $('.jsc-tax-invoice').append($companyHtml);

    // Remove Personal and Mobile Carrier No related cart attributes
    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Mobile Carrier No": ""
        }
      })
    });

  } else if ($val === 'Personal') {
    $('.jsc-tax-invoice').append($personalHtml);

    // Remove Company-related cart attributes
    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Company Name": "",
          "Company Registration No": "",
          "Tax Policy": "",
          "Mobile Carrier No": ""
        }
      })
    });

  } else if ($val === 'Mobile Carrier No') {
    $('.jsc-tax-invoice').append($mobileCarrierHtml);

    // Remove Company-related cart attributes
    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Company Name": "",
          "Company Registration No": "",
          "Tax Policy": ""
        }
      })
    });

  } else {
    // reset — clear all attributes
    await fetch('/cart/update.js', {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Mobile Carrier No": "",
          "Company Name": "",
          "Company Registration No": "",
          "Tax Policy": ""
        }
      })
    });
  }
};
const saveCartAttr = async (button) => {
    // If button is provided, normalize to jQuery object
    const $this = button ? $(button) : null;
    const $container = $this?.closest(".jsc-tax-invoice") || $(".jsc-tax-invoice");

    if (!$container.length) {
      console.log("⚠️ Tax invoice container not found.");
      return true; // No tax invoice section = skip validation
    }

    const $loader = $(".jsc-loader-overlay");
    $loader.show();

    const attributes = {};
    let passValidation = true;

    const $taxInvoiceType = $container.find('input[name="attributes[Tax Invoice for Legal Compliance]"]:checked');

    // Remove old error messages first
    $container.find(".jsc-tax-invoice-error-message").remove();

    if ($taxInvoiceType.length > 0 && $taxInvoiceType.val() !== "") {
      attributes["Tax Invoice for Legal Compliance"] = $taxInvoiceType.val();

      if ($taxInvoiceType.val() === "Company") {
        const $companyName = $container.find("#jsc-full-tax-company-name");
        const $companyRegistrationNo = $container.find("#jsc-full-tax-company-registration-no");

        // Company Name
        if ($companyName.length > 0 && $companyName.val() !== "") {
          attributes["Company Name"] = $companyName.val();
        } else {
          passValidation = false;
          $container.append(`<div class="jsc-tax-invoice-error-message">Please fill in the company name.</div>`);
        }

        // Company Registration No
        if ($companyRegistrationNo.length > 0 && $companyRegistrationNo.val() !== "") {
          const companyRegistrationNoTrim = $companyRegistrationNo.val().trim();
          if (/^\d{8}$/.test(companyRegistrationNoTrim)) {
            attributes["Company Registration No"] = $companyRegistrationNo.val();
          } else {
            passValidation = false;
            $container.append(`<div class="jsc-tax-invoice-error-message">Invalid company registration no.</div>`);
          }
        } else {
          passValidation = false;
          $container.append(`<div class="jsc-tax-invoice-error-message">Please fill in the company registration no.</div>`);
        }

      } else if ($taxInvoiceType.val() === "Mobile Carrier No") {
        const $mobileCarrierNo = $container.find("#jsc-mobile-carrier-no-mandatory");

        if ($mobileCarrierNo.length > 0 && $mobileCarrierNo.val() !== "") {
          const mobileCarrierNoTrim = $mobileCarrierNo.val().trim();
          if (/^.{8}$/.test(mobileCarrierNoTrim)) {
            attributes["Mobile Carrier No"] = $mobileCarrierNo.val();
          } else {
            passValidation = false;
            $container.append(`<div class="jsc-tax-invoice-error-message">Invalid mobile carrier no.</div>`);
          }
        } else {
          passValidation = false;
          $container.append(`<div class="jsc-tax-invoice-error-message">Please fill in the mobile carrier no.</div>`);
        }
      }

      // Tax Policy Checkbox
      const $taxPolicy = $container.find("#full-tax-invoice-policy");
      if ($taxPolicy.length > 0 && !$taxPolicy.is(':checked')) {
        passValidation = false;
        $container.append(`<div class="jsc-tax-invoice-error-message">Please agree to the Tax Policy.</div>`);
      } else if ($taxPolicy.length > 0 && $taxPolicy.is(':checked')) {
        attributes["Tax Policy"] = $taxPolicy.val();
      }
    } else {
      passValidation = false;
      $container.append(`<div class="jsc-tax-invoice-error-message">Please select a tax invoice type.</div>`);
    }

    if (passValidation) {
      try {
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes }),
        });

        const updatedCart = await res.json();
        console.log("✅ Cart attributes updated:", updatedCart);
        await addTaxInvoiceInfoAtLineItemProperties();

        // Optional feedback if button exists
        if ($this) {
          $this.text(`Saved!`).prop("disabled", true);
          setTimeout(() => {
            $this.text("Save to update").prop("disabled", false);
          }, 2000);
        }

      } catch (err) {
        console.error("❌ Failed to update cart attributes:", err);
        alert("Something went wrong. Please try again.");
        passValidation = false;
      } finally {
        $loader.hide();
      }
    } else {
      $loader.hide();
    }

    return passValidation;
};
getTaxAttr = async () =>{
    const $loader = $('.jsc-loader-overlay');
    $loader.show();
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const cart_attr_obj = cart.attributes;
    console.log('getCartAttr in getTaxAttr(): ',cart_attr_obj);
    if (cart.attributes['Tax Invoice for Legal Compliance']) {
        if (cart_attr_obj['Tax Invoice for Legal Compliance']) {
            const taxType = cart_attr_obj['Tax Invoice for Legal Compliance'];
            let id_key = taxType.toLowerCase();
            // Handle special case for "Mobile Carrier No"
            if (taxType === 'Mobile Carrier No') {
                id_key = 'mobile-carrier';
            }
            console.log('id_key',id_key);
            $(`#jsc-full-tax-${id_key}`).prop('checked', true).trigger('change');
        }
        if ($('#jsc-full-tax-company-name').length != 0) {
            $('#jsc-full-tax-company-name').val(cart_attr_obj['Company Name']);
        }
        if ($('#jsc-full-tax-company-registration-no').length != 0) {
            $('#jsc-full-tax-company-registration-no').val(cart_attr_obj['Company Registration No']);
        }
        if ($('#full-tax-invoice-policy').length != 0 && cart_attr_obj['Tax Policy'] === 'agreed') {
            $('#full-tax-invoice-policy').prop('checked', true);
        }
        if ($('#jsc-mobile-carrier-no-mandatory').length != 0) {
            $('#jsc-mobile-carrier-no-mandatory').val(cart_attr_obj['Mobile Carrier No']);
        }
    } else if (window.CustomerTaxInvoice) {
        console.log('window.CustomerTaxInvoice in getTaxAttr(): ',window.CustomerTaxInvoice);
        if (window.CustomerTaxInvoice.company_name && window.CustomerTaxInvoice.company_name != '' && window.CustomerTaxInvoice.company_registration_no && window.CustomerTaxInvoice.company_registration_no != '') {
            $(`#jsc-full-tax-company`).click();
            $('#jsc-full-tax-company-name').val(window.CustomerTaxInvoice.company_name);
            $('#jsc-full-tax-company-registration-no').val(window.CustomerTaxInvoice.company_registration_no);
        } else if (window.CustomerTaxInvoice.mobile_carrier_no && window.CustomerTaxInvoice.mobile_carrier_no != '') {
            $(`#jsc-full-tax-mobile-carrier`).click();
            $('#jsc-mobile-carrier-no-mandatory').val(window.CustomerTaxInvoice.mobile_carrier_no);
        }
    }
    $loader.hide();
}
$(document).on("focus input", "#jsc-full-tax-company-registration-no", function () {
    let val = $(this).val().replace(/\D/g, "");
    if (val.length > 8) val = val.slice(0, 8);
    $(this).val(val);
});
$(document).on("input", "#jsc-mobile-carrier-no-mandatory", function () {
    let val = $(this).val();

    // ✅ Remove spaces only (symbols, letters, numbers are allowed)
    val = val.replace(/\s/g, "");

    // ✅ Force first character to be "/"
    if (!val.startsWith("/")) {
      val = "/" + val.replace(/^\//g, "");
    }

    // ✅ Enforce EXACT total length = 8 (1 "/" + 7 others)
    val = val.slice(0, 8);

    $(this).val(val);
});
//end: tax invoice
//start: show disclaimer text for TM and KS product logic
hoverATCbutton = () => {
    $('.jsc-hover-atc-button').hover(
        function () {
            // on hover in
            var $disclaimer_text = $(this).siblings('.jsc-disclaimer-text-for-tm-and-ks');
            $disclaimer_text.fadeIn(200);
        },
        function () {
            // on hover out
            var $disclaimer_text = $(this).siblings('.jsc-disclaimer-text-for-tm-and-ks');
            $disclaimer_text.fadeOut(200);
        }
    );
}
//end: show disclaimer text for TM and KS product logic
// start: show popup when button with mixing restriction is clicked
$(document).on('click', 'button[data-show-mixing-popup="true"]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const sectionId = $this.data('section-id');
    console.log('sectionId', sectionId);

    if (!sectionId) return;

    const popup = $(`#jsc-mixing-popup-${sectionId}`);
    console.log('popup', popup);
    if (!popup.length) return;

    const closeButton = popup.find('.jsc-mixing-popup-close');
    const overlay = popup.find('.jsc-mixing-popup-overlay');
    const continueButton = popup.find('.jsc-continue-without-adding');
    const clearCartButton = popup.find('.jsc-clear-cart-and-add');

    console.log('closeButton', closeButton);
    console.log('overlay', overlay);

    popup.css('display', 'block');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    const closePopup = () => {
        popup.css('display', 'none');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
    }

    if (closeButton.length > 0) {
        closeButton.on('click', function(ce) {
            ce.preventDefault();
            ce.stopPropagation();
            closePopup();
        });
    }

    if (overlay.length > 0) {
        overlay.on('click', function(oe) {
            oe.preventDefault();
            oe.stopPropagation();
            closePopup();
        });
    }

    if (continueButton.length > 0) {
        continueButton.on('click', function(ctne) {
            ctne.preventDefault();
            ctne.stopPropagation();
            closePopup();
        });
    }

    if (clearCartButton.length > 0) {
        clearCartButton.on('click', function(ccte) {
            ccte.preventDefault();
            ccte.stopPropagation();
            fetch('/cart/clear.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                }
            })
            .then(response => response.json())
            .then(() => {
                // Now submit the form to add the current item
                $this.removeAttr('data-show-mixing-popup');
                $this.trigger('click');
            })
            .catch(error => {
                console.error('Error clearing cart:', error);
                alert('There was an error processing your request. Please try again.');
            });
        });
    }
});

// end: show popup when button with mixing restriction is clicked
// start: show popup when button with quantity limit restriction is clicked
$(document).on('click', 'button[data-show-quantity-limit-popup="true"]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(this);
    const sectionId = $this.data('section-id');
    console.log('sectionId', sectionId);

    if (!sectionId) return;

    const popup = $(`#jsc-quantity-limit-popup-${sectionId}`);
    console.log('popup', popup);
    if (!popup.length) return;

    const closeButton = popup.find('.jsc-mixing-popup-close');
    const overlay = popup.find('.jsc-mixing-popup-overlay');
    const continueButton = popup.find('.jsc-continue-without-adding');

    console.log('closeButton', closeButton);
    console.log('overlay', overlay);

    popup.css('display', 'block');
    $('body').css('overflow', 'hidden');
    $('body').addClass('mixing-popup-open');

    const closePopup = () => {
        popup.css('display', 'none');
        $('body').css('overflow', '');
        $('body').removeClass('mixing-popup-open');
    }

    if (overlay.length > 0) {
        overlay.on('click', function(oe) {
            oe.preventDefault();
            oe.stopPropagation();
            closePopup();
        });
    }

    if (continueButton.length > 0) {
        continueButton.on('click', function(ctne) {
            ctne.preventDefault();
            ctne.stopPropagation();
            closePopup();
        });
    }
});
// end: show popup when button with quantity limit restriction is clicked
// start: bundle reconciliation (PWP / GWP bundle lines)
// start: gwp reconcile from product metafields (cart page)
let reconcileGwpInProgress = false;
window.reconcileGwpInProgress = false;

/**
 * @param {object} it
 * @returns {boolean}
 */
const _gwpIsMain = (it) =>
  it.properties?._bundle_role === 'main' ||
  it.properties?._pwp_role === 'pwp_main' ||
  it.properties?._gwp_role === 'gwp_main';

/**
 * GWP gift line only. Must not match the bundle main: ATC sets main with
 * `_bundle_type: 'gwp'` when the bundle is GWP-only, but leaves `_gwp_role`
 * unset — so we must exclude `_bundle_role === 'main'` before treating
 * `_gwp_role == null` as a child (otherwise the main is misclassified and
 * queued for removal because its variant_id is not in gwpVariants).
 *
 * @param {object} it
 * @returns {boolean}
 */
const _gwpIsChild = (it) => {
  if (_gwpIsMain(it)) return false;
  const p = it.properties || {};
  return (
    p._bundle_type === 'gwp' &&
    (p._gwp_role === 'gwp_child' || p._gwp_role == null)
  );
};

/**
 * @param {string|number} bundleId
 * @returns {{ _bundle_type: string, _bundle_id: string|number, _gwp_role: string }}
 */
const _gwpChildProps = (bundleId) => ({
  _bundle_type: 'gwp',
  _bundle_id: bundleId,
  _gwp_role: 'gwp_child'
});

/**
 * @param {string|number} productId
 * @returns {string}
 */
const _gwpGenerateBundleId = (productId) =>
  `${productId}_${Math.floor(Date.now() / 1000)}_${Math.random().toString(36).slice(2, 9)}`;

/**
 * @param {object|null|undefined} props
 * @returns {object}
 */
const _gwpStripBundleProps = (props) => {
  const out = {};
  if (!props || typeof props !== 'object') return out;
  for (const [k, v] of Object.entries(props)) {
    if (k === '_bundle_id' || k === '_bundle_role' || k === '_bundle_type') continue;
    if (k === '_pwp_role' || k === '_gwp_role') continue;
    out[k] = v;
  }
  return out;
};

/**
 * When GWP children are gone but PWP children remain, demote a `mix` bundle main to `pwp`
 * (same `_bundle_id` / `_bundle_role`), matching bundle-upsell-pwp.js semantics.
 *
 * @param {string} base - Shop root without trailing slash
 * @param {object} headers - fetch headers for JSON cart APIs
 * @returns {Promise<boolean>} true if any main line was updated
 */
const _demoteMixMainToPwp = async (base, headers) => {
  const res = await fetch(base + '/cart.js?t=' + Date.now());
  const cart = await res.json();
  const items = cart.items || [];
  const byBundle = new Map();

  for (const item of items) {
    const p = item.properties || {};
    if (p._bundle_id == null) continue;
    const bid = String(p._bundle_id);
    if (!byBundle.has(bid)) byBundle.set(bid, { mains: [], children: [] });
    const g = byBundle.get(bid);
    if (p._bundle_role === 'main') {
      g.mains.push(item);
      continue;
    }
    if (
      (p._bundle_type === 'pwp' &&
        (p._pwp_role === 'pwp_main' || p._pwp_role == null)) ||
      (p._bundle_type === 'gwp' &&
        (p._gwp_role === 'gwp_main' || p._gwp_role == null))
    ) {
      g.mains.push(item);
      continue;
    }
    if (
      (p._bundle_type === 'pwp' &&
        (p._pwp_role === 'pwp_child' || p._pwp_role == null)) ||
      (p._bundle_type === 'gwp' &&
        (p._gwp_role === 'gwp_child' || p._gwp_role == null))
    ) {
      g.children.push(item);
    }
  }

  let changed = false;
  for (const [, group] of byBundle) {
    const activeChildren = group.children.filter((c) => c.quantity > 0);
    const hasGwpChild = activeChildren.some((c) => c.properties?._bundle_type === 'gwp');
    const hasPwpChild = activeChildren.some((c) => c.properties?._bundle_type === 'pwp');

    for (const mainLine of group.mains) {
      if (mainLine.quantity <= 0) continue;
      if (mainLine.properties?._bundle_type !== 'mix') continue;
      if (hasGwpChild || !hasPwpChild) continue;

      const newProps = Object.assign({}, mainLine.properties || {}, {
        _bundle_type: 'pwp'
      });
      const demoteRes = await fetch(base + '/cart/change.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          id: mainLine.key,
          quantity: mainLine.quantity,
          properties: newProps
        }),
        credentials: 'same-origin'
      });
      if (demoteRes.ok) {
        changed = true;
      } else {
        console.warn('[reconcileGwpFromMetafield] demote mix→pwp failed', mainLine.key, demoteRes.status);
      }
    }
  }
  return changed;
};

/**
 * Reconciles main cart lines against each product's current metafields.custom.gwp
 * (rendered into #cart-gwp-config). Adds missing gwp_child lines, removes stale gifts,
 * rebuilds legacy mains without _bundle_id. Intended for /cart page load only.
 *
 * @param {Object} options
 * @param {boolean} [options.debug]
 * @returns {Promise<{ changed: boolean }>}
 */
const reconcileGwpFromMetafield = async (options = {}) => {
  const debug = options.debug === true;
  if (reconcileGwpInProgress) return { changed: false };

  const cfgEl = document.getElementById('cart-gwp-config');
  if (!cfgEl) return { changed: false };

  let cfg = {};
  try {
    cfg = JSON.parse(cfgEl.textContent || '{}');
  } catch (e) {
    return { changed: false };
  }

  reconcileGwpInProgress = true;
  window.reconcileGwpInProgress = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const base = root.replace(/\/$/, '');

  let $loader = typeof $ !== 'undefined' ? $('.jsc-loader-overlay') : { length: 0 };
  try {
    const res = await fetch(base + '/cart.js');
    const cart = await res.json();
    const items = cart.items || [];

    const childrenByBundle = new Map();
    for (const it of items) {
      if (!_gwpIsChild(it) || it.properties?._bundle_id == null) continue;
      const k = String(it.properties._bundle_id);
      if (!childrenByBundle.has(k)) childrenByBundle.set(k, []);
      childrenByBundle.get(k).push(it);
    }

    const removeKeys = [];
    const addItems = [];
    /** @type {typeof items} */
    const rebuilds = [];

    for (const line of items) {
      const cfgEntry = cfg[line.product_id];
      if (!_gwpIsMain(line)) {
        if (cfgEntry && line.properties?._bundle_id == null) rebuilds.push(line);
        continue;
      }
      const expected = new Set((cfgEntry?.gwpVariants || []).map((id) => String(id)));
      const bundleId = line.properties?._bundle_id;
      const existing = bundleId ? childrenByBundle.get(String(bundleId)) || [] : [];
      for (const child of existing) {
        const childVariantId = String(child.variant_id);
        if (expected.has(childVariantId)) expected.delete(childVariantId);
        else removeKeys.push(child.key);
      }
      if (bundleId) {
        for (const vid of expected) {
          addItems.push({ id: vid, quantity: 1, properties: _gwpChildProps(bundleId) });
        }
      }
    }

    const headers = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json'
    };

    const needsGwpMutation =
      removeKeys.length > 0 || addItems.length > 0 || rebuilds.length > 0;

    if (needsGwpMutation && debug) {
      console.log('[reconcileGwpFromMetafield]', { removeKeys, addItems, rebuilds });
    }

    if (needsGwpMutation) {
      if ($loader.length) {
        $loader.show();
        document.body.style.overflow = 'hidden';
      }

    if (removeKeys.length) {
      const updates = {};
      for (const k of [...new Set(removeKeys)]) updates[k] = 0;
      const updateRes = await fetch(base + '/cart/update.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ updates: updates }),
        credentials: 'same-origin'
      });
      if (!updateRes.ok) console.warn('[reconcileGwpFromMetafield] cart/update.js failed', updateRes.status);
    }
    if (addItems.length) {
      const addRes = await fetch(base + '/cart/add.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ items: addItems }),
        credentials: 'same-origin'
      });
      if (!addRes.ok) console.warn('[reconcileGwpFromMetafield] cart/add.js failed', addRes.status);
    }
    for (const line of rebuilds) {
      const cfgEntry = cfg[line.product_id];
      if (!cfgEntry || !cfgEntry.gwpVariants?.length) continue;
      const bundleId = _gwpGenerateBundleId(line.product_id);
      const zeroRes = await fetch(base + '/cart/update.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ updates: { [line.key]: 0 } }),
        credentials: 'same-origin'
      });
      if (!zeroRes.ok) console.warn('[reconcileGwpFromMetafield] rebuild zero-out failed', zeroRes.status);

      const mainProps = Object.assign({}, _gwpStripBundleProps(line.properties), {
        _bundle_role: 'main',
        _bundle_type: 'gwp',
        _bundle_id: bundleId
      });
      const rebuildItems = [
        {
          id: line.variant_id,
          quantity: line.quantity,
          properties: mainProps
        }
      ];
      for (const vid of cfgEntry.gwpVariants) {
        rebuildItems.push({ id: vid, quantity: 1, properties: _gwpChildProps(bundleId) });
      }
      const rebuildRes = await fetch(base + '/cart/add.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ items: rebuildItems }),
        credentials: 'same-origin'
      });
      if (!rebuildRes.ok) console.warn('[reconcileGwpFromMetafield] rebuild add failed', rebuildRes.status);
    }
    }

    const demotedMixToPwp = await _demoteMixMainToPwp(base, headers);

    if (!needsGwpMutation && !demotedMixToPwp) {
      return { changed: false };
    }

    reconcileGwpInProgress = false;
    window.reconcileGwpInProgress = false;

    const refreshedRes = await fetch(base + '/cart.js?t=' + Date.now());
    const refreshed = await refreshedRes.json();
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: refreshed },
        bubbles: true
      })
    );
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    return { changed: true };
  } catch (err) {
    console.error('[reconcileGwpFromMetafield] Error:', err);
    return { changed: false };
  } finally {
    if ($loader.length) {
      $loader.hide();
      document.body.style.overflow = '';
    }
    reconcileGwpInProgress = false;
    window.reconcileGwpInProgress = false;
  }
};

window.reconcileGwpFromMetafield = reconcileGwpFromMetafield;
// end: gwp reconcile from product metafields

/** Line-item keys added by PWP/GWP bundle flows; strip these instead of removing the paid main line. */
const _BUNDLE_LINE_PROPERTY_KEYS = [
  '_bundle_type',
  '_bundle_id',
  '_bundle_role',
  '_pwp_role',
  '_gwp_role'
];

/**
 * @param {object|null|undefined} props
 * @returns {object}
 */
const _stripBundleLineProperties = (props) => {
  const strip = new Set(_BUNDLE_LINE_PROPERTY_KEYS);
  const out = {};
  for (const [k, v] of Object.entries(props || {})) {
    if (strip.has(k)) continue;
    out[k] = v;
  }
  return out;
};

/**
 * Orphan bundle main (no bundle children left): strip `_bundle_type` / `_bundle_id` /
 * `_bundle_role` only for pure GWP mains (`_bundle_type === 'gwp'`). For `mix` or `pwp`
 * mains, PWP is involved — keep those keys and only strip `_pwp_role` / `_gwp_role`.
 *
 * @param {object|null|undefined} props
 * @returns {object}
 */
const _stripOrphanMainBundleProperties = (props) => {
  const p = props || {};
  const bt = p._bundle_type;
  if (bt === 'mix' || bt === 'pwp') {
    const out = {};
    for (const [k, v] of Object.entries(p)) {
      if (k === '_pwp_role' || k === '_gwp_role') continue;
      out[k] = v;
    }
    return out;
  }
  return _stripBundleLineProperties(props);
};

let reconcileBundleItemsInProgress = false;

/**
 * Validates and enforces bundle relationships in the cart using _bundle_id, _bundle_role (main), or legacy _pwp_role / _gwp_role.
 * Removes orphaned children (no main or main qty 0). Orphan bundle mains (no remaining children) stay in the cart:
 * bundle line properties are cleared via cart/change.js instead of removing the line.
 *
 * Flow when the buyer removes the main line (or sets its qty to 0): that update completes first; then
 * cart:updated runs this function. It fetches /cart.js, finds orphan lines for the same _bundle_id, and
 * removes them in one POST /cart/update.js ({ updates: { lineKey: 0, ... } }) so the cart updates
 * atomically; falls back to parallel /cart/change.js if batch fails. Then uses the returned cart
 * (or GET /cart.js) and dispatches cart:updated and cart:build so CartForm rebuilds the drawer and
 * cart page. Shows .jsc-loader-overlay only while removals run.
 *
 * Use after quantity updates, item removal, or cart refresh. Prevents infinite loops via re-entry guard.
 * @param {Object} options
 * @param {boolean} options.debug - Log inconsistencies to console
 * @returns {Promise<{ changed: boolean, removed?: number, stripped?: number }>}
 */
const reconcileBundleItems = async (options = {}) => {
  const debug = options.debug === true;
  if (reconcileBundleItemsInProgress) {
    if (debug) console.log('[reconcileBundleItems] Skipped: already in progress');
    return { changed: false };
  }
  reconcileBundleItemsInProgress = true;
  let $loader = { length: 0 };
  try {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const base = root.replace(/\/$/, '');
    const res = await fetch(base + '/cart.js');
    const cart = await res.json();
    const items = cart.items || [];
    const byBundle = {};
    for (const item of items) {
      const props = item.properties || {};
      const bid = props._bundle_id != null ? props._bundle_id : null;
      if (bid == null) continue;
      const id = String(bid);
      if (!byBundle[id]) byBundle[id] = { main: [], child: [] };
      if (props._bundle_role === 'main') {
        byBundle[id].main.push(item);
        continue;
      }
      if (
        (props._bundle_type === 'pwp' &&
          (props._pwp_role === 'pwp_main' || props._pwp_role == null)) ||
        (props._bundle_type === 'gwp' &&
          (props._gwp_role === 'gwp_main' || props._gwp_role == null))
      ) {
        byBundle[id].main.push(item);
        continue;
      }
      if (
        (props._bundle_type === 'pwp' &&
          (props._pwp_role === 'pwp_child' || props._pwp_role == null)) ||
        (props._bundle_type === 'gwp' &&
          (props._gwp_role === 'gwp_child' || props._gwp_role == null))
      ) {
        byBundle[id].child.push(item);
      }
    }
    const orphanChildKeys = [];
    /** @type {Map<string, object>} */
    const mainsToStripByKey = new Map();
    const missingMain = [];
    const missingChild = [];
    for (const [bundleId, group] of Object.entries(byBundle)) {
      const mainWithQty = group.main.filter((m) => m.quantity > 0);
      const childWithQty = group.child.filter((c) => c.quantity > 0);
      for (const c of group.child) {
        if (c.quantity === 0) continue;
        if (mainWithQty.length === 0) {
          orphanChildKeys.push(c.key);
          if (debug) missingMain.push({ bundleId, key: c.key });
        }
      }
      for (const m of group.main) {
        if (m.quantity === 0) continue;
        if (childWithQty.length === 0) {
          mainsToStripByKey.set(m.key, m);
          if (debug) missingChild.push({ bundleId, key: m.key });
        }
      }
    }
    if (debug && (missingMain.length || missingChild.length)) {
      console.log('[reconcileBundleItems] Inconsistencies:', { missingMain, missingChild });
    }
    const mainsToStrip = [...mainsToStripByKey.values()];
    if (orphanChildKeys.length === 0 && mainsToStrip.length === 0) {
      return { changed: false };
    }
    $loader = typeof $ !== 'undefined' ? $('.jsc-loader-overlay') : { length: 0 };
    if ($loader.length) {
      $loader.show();
      document.body.style.overflow = 'hidden';
    }
    const headers = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json'
    };
    const uniqueOrphanChildKeys = [...new Set(orphanChildKeys)];
    if (uniqueOrphanChildKeys.length) {
      const updates = {};
      for (const key of uniqueOrphanChildKeys) {
        updates[key] = 0;
      }
      const updateUrl = base + '/cart/update.js';
      let batchRes = await fetch(updateUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ updates: updates }),
        credentials: 'same-origin'
      });
      if (!batchRes.ok) {
        const changeUrl = base + '/cart/change.js';
        await Promise.all(
          uniqueOrphanChildKeys.map((key) =>
            fetch(changeUrl, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({ id: key, quantity: 0 }),
              credentials: 'same-origin'
            })
          )
        );
      }
    }
    for (const mainLine of mainsToStrip) {
      const stripRes = await fetch(base + '/cart/change.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          id: mainLine.key,
          quantity: mainLine.quantity,
          properties: _stripOrphanMainBundleProperties(mainLine.properties)
        }),
        credentials: 'same-origin'
      });
      if (!stripRes.ok) {
        console.warn('[reconcileBundleItems] strip bundle props failed', mainLine.key, stripRes.status);
      }
    }
    const cartRefresh = await fetch(base + '/cart.js?t=' + Date.now()).then((r) => r.json());
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: cartRefresh },
        bubbles: true
      })
    );
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    return {
      changed: true,
      removed: uniqueOrphanChildKeys.length,
      stripped: mainsToStrip.length
    };
  } catch (err) {
    console.error('[reconcileBundleItems] Error:', err);
    return { changed: false };
  } finally {
    if ($loader.length) {
      $loader.hide();
      document.body.style.overflow = '';
    }
    reconcileBundleItemsInProgress = false;
  }
};

window.reconcileBundleItems = reconcileBundleItems;

// start: oos item removal
let reconcileOosItemsInProgress = false;

/**
 * Reads window.cartItemsProductTags (rendered into theme.liquid on every page),
 * fetches the current cart, and removes any line items whose product carries
 * the "oos" tag via a single POST /cart/update.js.
 *
 * No product API fetches or client-side cache needed — tags are server-rendered
 * for every product currently in the cart at page load time.
 * Returns { changed: false } immediately if window.cartItemsProductTags is absent.
 *
 * @param {Object} options
 * @param {boolean} [options.debug]
 * @returns {Promise<{ changed: boolean, removed?: number }>}
 */
const reconcileOosItems = async (options = {}) => {
  const debug = options.debug === true;

  if (reconcileOosItemsInProgress) {
    if (debug) console.log('[reconcileOosItems] Skipped: already in progress');
    return { changed: false };
  }

  const tagsByHandle = window.cartItemsProductTags;
  if (!tagsByHandle || typeof tagsByHandle !== 'object') return { changed: false };

  reconcileOosItemsInProgress = true;
  let $loader = { length: 0 };

  try {
    const root = (window.Shopify?.routes?.root) || '/';
    const base = root.replace(/\/$/, '');

    const cartRes = await fetch(base + '/cart.js');
    const cart = await cartRes.json();
    const items = cart.items || [];

    const oosKeys = [];
    for (const item of items) {
      if (item.quantity === 0) continue;
      const tags = tagsByHandle[item.handle] || [];
      if (tags.includes('oos')) {
        oosKeys.push(item.key);
        if (debug) {
          console.log('[reconcileOosItems] OOS item flagged for removal:', {
            title: item.title,
            handle: item.handle,
            key: item.key
          });
        }
      }
    }

    if (oosKeys.length === 0) {
      if (debug) console.log('[reconcileOosItems] No OOS items found');
      return { changed: false };
    }

    $loader = typeof $ !== 'undefined' ? $('.jsc-loader-overlay') : { length: 0 };
    if ($loader.length) {
      $loader.show();
      document.body.style.overflow = 'hidden';
    }

    const headers = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json'
    };

    const uniqueOosKeys = [...new Set(oosKeys)];
    const updates = {};
    for (const key of uniqueOosKeys) {
      updates[key] = 0;
    }

    const updateRes = await fetch(base + '/cart/update.js', {
      method: 'POST',
      headers,
      body: JSON.stringify({ updates }),
      credentials: 'same-origin'
    });

    if (!updateRes.ok) {
      console.warn('[reconcileOosItems] cart/update.js failed', updateRes.status);
      return { changed: false };
    }

    if (debug) console.log('[reconcileOosItems] Removed OOS lines:', uniqueOosKeys.length);

    const refreshedCart = await fetch(base + '/cart.js?t=' + Date.now()).then((r) => r.json());
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: refreshedCart },
        bubbles: true
      })
    );
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

    return { changed: true, removed: uniqueOosKeys.length };
  } catch (err) {
    console.error('[reconcileOosItems] Error:', err);
    return { changed: false };
  } finally {
    if ($loader.length) {
      $loader.hide();
      document.body.style.overflow = '';
    }
    reconcileOosItemsInProgress = false;
  }
};

window.reconcileOosItems = reconcileOosItems;
// end: oos item removal

/**
 * Hook into existing cart flow:
 * - On cart:updated (quantity change, item removal, etc.): reconcile orphans; reconcile dispatches
 *   cart:updated + cart:build when it removes lines (nested reconcile skipped while in progress).
 * - On every page load: run OOS removal once using window.cartItemsProductTags.
 * - On cart page load only: run in sequence — GWP → OOS → bundle — stopping the chain
 *   early whenever a pass makes changes (each pass dispatches cart:updated itself).
 */
function applyBundleReconciliationHooks() {
  document.addEventListener('cart:updated', function onCartUpdated() {
    if (window.reconcileGwpInProgress) return;
    window.reconcileBundleItems({ debug: false });
  });

  if (window.location.pathname.includes('/cart')) {
    setTimeout(async function () {
      const gwpResult = await window.reconcileGwpFromMetafield({ debug: false });
      if (!gwpResult.changed) {
        const oosResult = await window.reconcileOosItems({ debug: false });
        if (!oosResult.changed) {
          window.reconcileBundleItems({ debug: false });
        }
      }
    }, 0);
  } else {
    setTimeout(function () {
      window.reconcileOosItems({ debug: false });
    }, 0);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyBundleReconciliationHooks);
} else {
  applyBundleReconciliationHooks();
}
// end: bundle reconciliation

// start: mobile scrollable grid — hide native scrollbar, show indicator while swiping
(function () {
  var SCROLL_HIDE_DELAY = 450;
  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');

  function isMobileScrollContext() {
    return MOBILE_MQ.matches;
  }

  function updateScrollIndicator(grid, host, indicator, thumb) {
    var scrollWidth = grid.scrollWidth;
    var clientWidth = grid.clientWidth;
    var maxScroll = scrollWidth - clientWidth;

    if (maxScroll <= 1) {
      indicator.hidden = true;
      return;
    }

    indicator.hidden = false;
    var thumbWidthPercent = Math.max((clientWidth / scrollWidth) * 100, 18);
    var travel = 100 - thumbWidthPercent;
    var thumbLeftPercent = maxScroll > 0 ? (grid.scrollLeft / maxScroll) * travel : 0;

    thumb.style.width = thumbWidthPercent + '%';
    thumb.style.left = thumbLeftPercent + '%';
  }

  function bindScrollableGrid(grid) {
    if (!grid || grid.dataset.scrollIndicatorInit === 'true') {
      return;
    }
    if (!grid.classList.contains('scrollable-grid--small')) {
      return;
    }

    grid.dataset.scrollIndicatorInit = 'true';

    var host = document.createElement('div');
    host.className = 'scrollable-grid-host';
    grid.parentNode.insertBefore(host, grid);
    host.appendChild(grid);

    var indicator = document.createElement('div');
    indicator.className = 'scrollable-grid-indicator';
    indicator.setAttribute('aria-hidden', 'true');
    indicator.innerHTML = '<div class="scrollable-grid-indicator__thumb"></div>';
    host.appendChild(indicator);

    var thumb = indicator.querySelector('.scrollable-grid-indicator__thumb');
    var scrollHideTimer;

    function showIndicator() {
      if (!isMobileScrollContext()) {
        return;
      }
      host.classList.add('is-scrolling');
    }

    function hideIndicatorSoon() {
      clearTimeout(scrollHideTimer);
      scrollHideTimer = setTimeout(function () {
        host.classList.remove('is-scrolling');
      }, SCROLL_HIDE_DELAY);
    }

    function onScroll() {
      showIndicator();
      updateScrollIndicator(grid, host, indicator, thumb);
      hideIndicatorSoon();
    }

    grid.addEventListener('scroll', onScroll, { passive: true });
    grid.addEventListener('touchstart', showIndicator, { passive: true });
    grid.addEventListener('touchend', hideIndicatorSoon, { passive: true });
    grid.addEventListener('pointerdown', showIndicator, { passive: true });
    grid.addEventListener('pointerup', hideIndicatorSoon, { passive: true });

    window.addEventListener(
      'resize',
      function () {
        updateScrollIndicator(grid, host, indicator, thumb);
        if (!isMobileScrollContext()) {
          host.classList.remove('is-scrolling');
        }
      },
      { passive: true }
    );

    updateScrollIndicator(grid, host, indicator, thumb);
  }

  function initScrollableGridIndicators(root) {
    if (!isMobileScrollContext()) {
      return;
    }
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.new-grid.scrollable-grid--small').forEach(bindScrollableGrid);
  }

  window.initScrollableGridIndicators = initScrollableGridIndicators;

  $(function () {
    initScrollableGridIndicators();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initScrollableGridIndicators(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initScrollableGridIndicators();
  });
})();
// end: mobile scrollable grid
